import React from "react";

export const clipboardIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_104_1426)">
      <path d="M20.3873 2.16239C19.9008 1.6748 19.2537 1.40625 18.5653 1.40625H17.4024V1.17188C17.4024 0.525703 16.8767 0 16.2305 0H7.793C7.14683 0 6.62113 0.525703 6.62113 1.17188V1.40625H5.45408C4.03559 1.40625 2.88027 2.56153 2.87867 3.98152L2.85941 21.419C2.85866 22.1082 3.12617 22.7563 3.61269 23.2439C4.09925 23.7315 4.74636 24 5.43481 24H18.5459C19.9645 24 21.1198 22.8447 21.1213 21.4247L21.1407 3.98723C21.1415 3.29803 20.8739 2.64994 20.3873 2.16239ZM8.02738 1.40625H15.9961V2.8125H8.02738V1.40625ZM19.7166 21.4231C19.7158 22.0687 19.1907 22.5938 18.5459 22.5938H5.43481C5.12188 22.5938 4.82774 22.4717 4.60658 22.2501C4.38542 22.0284 4.26383 21.7338 4.26416 21.4206L4.28342 3.98311C4.28413 3.33759 4.80927 2.8125 5.45408 2.8125H6.62113V3.04688C6.62113 3.69305 7.14683 4.21875 7.793 4.21875H16.2305C16.8767 4.21875 17.4024 3.69305 17.4024 3.04688V2.8125H18.5653C18.8782 2.8125 19.1723 2.93456 19.3935 3.15619C19.6146 3.37781 19.7363 3.67242 19.7359 3.98564L19.7166 21.4231Z" />
      <path d="M12.239 9.375H17.2345C17.6228 9.375 17.9377 9.06019 17.9377 8.67188C17.9377 8.28356 17.6228 7.96875 17.2345 7.96875H12.239C11.8507 7.96875 11.5359 8.28356 11.5359 8.67188C11.5359 9.06019 11.8507 9.375 12.239 9.375Z" />
      <path d="M12.239 14.0625H17.2345C17.6228 14.0625 17.9377 13.7477 17.9377 13.3594C17.9377 12.9711 17.6228 12.6562 17.2345 12.6562H12.239C11.8507 12.6562 11.5359 12.9711 11.5359 13.3594C11.5359 13.7477 11.8507 14.0625 12.239 14.0625Z" />
      <path d="M17.2546 17.3438H12.239C11.8507 17.3438 11.5359 17.6586 11.5359 18.0469C11.5359 18.4352 11.8507 18.75 12.239 18.75H17.2546C17.643 18.75 17.9578 18.4352 17.9578 18.0469C17.9578 17.6586 17.643 17.3438 17.2546 17.3438Z" />
      <path d="M9.24641 6.7577L7.62491 8.3792L7.2426 7.99684C6.96801 7.72224 6.52284 7.72224 6.24824 7.99684C5.97365 8.27138 5.97365 8.7166 6.24824 8.9912L7.12776 9.87076C7.25962 10.0026 7.43845 10.0767 7.62496 10.0767C7.81143 10.0767 7.99026 10.0027 8.12212 9.87076L10.2408 7.7521C10.5154 7.47756 10.5154 7.03234 10.2408 6.75774C9.96623 6.4831 9.52106 6.4831 9.24641 6.7577Z" />
      <path d="M9.24641 11.8026L7.62491 13.4241L7.2426 13.0418C6.96801 12.7672 6.52284 12.7672 6.24824 13.0418C5.97365 13.3163 5.97365 13.7615 6.24824 14.0361L7.12776 14.9157C7.25962 15.0476 7.43845 15.1217 7.62496 15.1217C7.81143 15.1217 7.99031 15.0476 8.12212 14.9157L10.2408 12.797C10.5154 12.5224 10.5154 12.0772 10.2408 11.8026C9.96623 11.528 9.52101 11.528 9.24641 11.8026Z" />
      <path d="M9.24641 16.4901L7.62491 18.1116L7.2426 17.7293C6.96801 17.4547 6.52284 17.4547 6.24824 17.7293C5.97365 18.0038 5.97365 18.449 6.24824 18.7236L7.12776 19.6032C7.25962 19.7351 7.43845 19.8092 7.62496 19.8092C7.81143 19.8092 7.99031 19.7351 8.12212 19.6032L10.2408 17.4845C10.5154 17.2099 10.5154 16.7647 10.2408 16.4901C9.96623 16.2155 9.52101 16.2155 9.24641 16.4901Z" />
    </g>
    <defs>
      <clipPath id="clip0_104_1426">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const tickIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icons8-checkmark 1">
      <path
        id="Vector"
        d="M10.636 13.6634C10.4563 13.6634 10.2841 13.5859 10.165 13.4493L6.80126 9.59434C6.57408 9.33434 6.60095 8.93934 6.86095 8.71246C7.12158 8.48527 7.51626 8.51277 7.74283 8.77246L10.5619 12.0028L15.1003 4.98871C15.2881 4.69902 15.6747 4.6159 15.9647 4.8034C16.2544 4.9909 16.3372 5.37777 16.1497 5.66777L11.1606 13.3781C11.0541 13.5428 10.8766 13.6481 10.6806 13.6621C10.6656 13.6631 10.651 13.6634 10.636 13.6634Z"
        fill="inherit"
      />
      <path
        id="Vector_2"
        d="M16.2781 7.2C16.6625 8.05313 16.875 9.00312 16.875 10C16.875 13.7969 13.7969 16.875 10 16.875C6.20313 16.875 3.125 13.7969 3.125 10C3.125 6.20313 6.20313 3.125 10 3.125C11.6031 3.125 13.075 3.67187 14.2438 4.59062L13.5625 5.64687C12.5938 4.85312 11.3531 4.375 10 4.375C6.89375 4.375 4.375 6.89375 4.375 10C4.375 13.1062 6.89375 15.625 10 15.625C13.1062 15.625 15.625 13.1062 15.625 10C15.625 9.4875 15.5563 8.99063 15.425 8.51875L16.2781 7.2Z"
        fill="inherit"
      />
    </g>
  </svg>
);

export const circleArrow = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icons8-update 1">
      <path
        id="Vector"
        d="M9.15771 1.875C8.94643 1.87289 8.75 2.04078 8.75 2.27844V3.24096C5.55419 3.83075 3.125 6.6361 3.125 10C3.125 13.7909 6.20906 16.875 10 16.875C13.7909 16.875 16.875 13.7909 16.875 10C16.875 7.825 15.8284 5.75507 14.0759 4.46289C13.7981 4.25789 13.406 4.31722 13.2019 4.59472C12.9969 4.87254 13.0562 5.26436 13.3344 5.46936C14.7687 6.52686 15.625 8.22062 15.625 10C15.625 13.1016 13.1016 15.625 10 15.625C6.89844 15.625 4.375 13.1016 4.375 10C4.375 7.32856 6.24891 5.09088 8.75 4.52026V5.22155C8.75 5.53843 9.09894 5.73149 9.36707 5.56274L11.6614 4.11804C11.9326 3.94741 11.9326 3.55197 11.6614 3.38134L9.36707 1.93725C9.30003 1.89507 9.22814 1.8757 9.15771 1.875Z"
        fill="inherit"
      />
    </g>
  </svg>
);

export const fireIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
  >
    <path d="M15.307 7.49128C11.0231 4.88498 13.032 1.20638 13.1182 1.05347C13.2432 0.835875 13.2429 0.568172 13.1171 0.350953C12.9915 0.133734 12.7595 0 12.5086 0C10.3034 0 8.57664 0.626531 7.37622 1.86225C5.32502 3.97373 5.42017 7.26 5.46076 8.66334C5.46527 8.81878 5.46916 8.95312 5.46916 9.05288C5.46916 10.0948 5.63631 11.0567 5.78383 11.9054C5.87889 12.4523 5.96097 12.9246 5.97555 13.296C5.99116 13.6935 5.91859 13.7846 5.9155 13.7882C5.90514 13.8005 5.81889 13.8464 5.58569 13.8464C5.31972 13.8464 5.12364 13.7595 4.94992 13.5647C4.27136 12.8039 4.22444 10.7263 4.35419 9.59597C4.37739 9.39666 4.31434 9.19697 4.18089 9.04716C4.04748 8.89734 3.85642 8.81166 3.6558 8.81166C1.83025 8.81166 0.466141 11.797 0.466141 14.4663C0.466141 15.7211 0.718516 16.9503 1.21628 18.1197C1.6975 19.2502 2.3837 20.2706 3.25591 21.1523C5.07241 22.9887 7.46739 24 9.99977 24C12.5423 24 14.9367 23.003 16.7418 21.1927C18.5423 19.387 19.5339 16.9981 19.5339 14.4662C19.5338 11.2355 17.006 8.52492 15.307 7.49128ZM9.99977 22.5938C5.59431 22.5938 1.87244 18.8718 1.87244 14.4662C1.87244 13.3948 2.12809 12.2701 2.57383 11.3806C2.67794 11.1728 2.78477 10.9946 2.89019 10.8444C2.90195 12.0044 3.0857 13.5857 3.89922 14.4993C4.33806 14.9921 4.92123 15.2526 5.58573 15.2526C6.2065 15.2526 6.67956 15.0645 6.99166 14.6934C7.57516 13.9997 7.39605 12.9692 7.16936 11.6646C7.03159 10.8719 6.87545 9.97345 6.87545 9.05283C6.87545 8.93269 6.87128 8.78902 6.8665 8.62256C6.82801 7.29328 6.74791 4.52723 8.38492 2.84212C9.11978 2.08561 10.1458 1.6252 11.4437 1.46766C11.2972 1.95422 11.1709 2.57189 11.166 3.26348C11.1552 4.7873 11.7381 6.96609 14.5761 8.69269C15.9492 9.52805 18.1276 11.8342 18.1276 14.4662C18.1276 18.9478 14.4814 22.5938 9.99977 22.5938Z" />
  </svg>
);

export const indicesIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Up down sort (1) 1">
      <path
        id="Vector"
        d="M18.7498 9.75003H5.24984C5.10153 9.74999 4.95655 9.70599 4.83325 9.62358C4.70994 9.54116 4.61383 9.42404 4.55708 9.28702C4.50033 9.14999 4.48548 8.99922 4.5144 8.85375C4.54333 8.70829 4.61473 8.57467 4.71959 8.46978L11.4696 1.71978C11.5392 1.6501 11.6219 1.59483 11.7128 1.55712C11.8038 1.51941 11.9014 1.5 11.9998 1.5C12.0983 1.5 12.1959 1.51941 12.2868 1.55712C12.3778 1.59483 12.4605 1.6501 12.5301 1.71978L19.2801 8.46978C19.3849 8.57467 19.4564 8.70829 19.4853 8.85375C19.5142 8.99922 19.4994 9.14999 19.4426 9.28702C19.3858 9.42404 19.2897 9.54116 19.1664 9.62358C19.0431 9.70599 18.8982 9.74999 18.7498 9.75003ZM7.06042 8.25003H16.9393L11.9998 3.3106L7.06042 8.25003Z"
        fill="inherit"
      />
      <path
        id="Vector_2"
        d="M11.9998 22.5C11.9013 22.5001 11.8038 22.4808 11.7128 22.443C11.6218 22.4053 11.5391 22.35 11.4696 22.2803L4.71959 15.5303C4.61473 15.4254 4.54333 15.2917 4.5144 15.1463C4.48548 15.0008 4.50033 14.85 4.55708 14.713C4.61383 14.576 4.70994 14.4589 4.83325 14.3764C4.95655 14.294 5.10153 14.25 5.24984 14.25H18.7498C18.8982 14.25 19.0431 14.294 19.1664 14.3764C19.2897 14.4589 19.3858 14.576 19.4426 14.713C19.4994 14.85 19.5142 15.0008 19.4853 15.1463C19.4564 15.2917 19.3849 15.4254 19.2801 15.5303L12.5301 22.2803C12.4605 22.35 12.3779 22.4053 12.2869 22.443C12.1959 22.4808 12.0983 22.5001 11.9998 22.5ZM7.06042 15.75L11.9998 20.6894L16.9393 15.75H7.06042Z"
        fill="inherit"
      />
    </g>
  </svg>
);

export const detectiveIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Detective icon 1" clipPath="url(#clip0_952_6019)">
      <mask
        id="mask0_952_6019"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <g id="Group">
          <path id="bg" d="M24 0H0V24H24V0Z" fill="white" />
        </g>
      </mask>
      <g mask="url(#mask0_952_6019)">
        <g id="Group_2">
          <g id="g57">
            <g id="g71">
              <g id="Clip path group">
                <mask
                  id="mask1_952_6019"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="24"
                  height="24"
                >
                  <g id="clipPath77">
                    <path
                      id="path75"
                      d="M0 1.90735e-06H24V24H0V1.90735e-06Z"
                      fill="white"
                    />
                  </g>
                </mask>
                <g mask="url(#mask1_952_6019)">
                  <g id="g73">
                    <g id="g79">
                      <path
                        id="path81"
                        d="M20.6561 7.48034C20.3623 7.31263 20.0555 7.169 19.7417 7.04267L18.9185 6.71127C18.0881 -3.37277 13.0498 2.30473 12.053 2.30473C11.0561 2.30473 6.01792 -3.37272 5.18753 6.71127L4.36455 7.04263C4.05072 7.16895 3.74378 7.31263 3.44992 7.48039C2.26769 8.15525 1.57422 8.97566 1.57422 9.86061C1.57427 12.163 6.2657 14.0293 12.053 14.0293C17.8403 14.0293 22.5317 12.163 22.5317 9.86061C22.5317 8.9757 21.8384 8.1552 20.6561 7.48034Z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.40625"
                        strokeMiterlimit="10"
                      />
                    </g>
                    <g id="g83">
                      <path
                        id="path85"
                        d="M5.17969 6.7282C7.01977 7.76062 9.42403 8.38574 12.0547 8.38574C14.6853 8.38574 17.0895 7.76066 18.9295 6.72829"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.40625"
                        strokeMiterlimit="10"
                      />
                    </g>
                    <g id="g87">
                      <path
                        id="path89"
                        d="M9.92533 19.6623C9.92533 21.6674 8.29984 23.293 6.29472 23.293C4.28959 23.293 2.66406 21.6674 2.66406 19.6623C2.66406 17.6572 4.28959 16.0317 6.29472 16.0317C8.29984 16.0317 9.92533 17.6572 9.92533 19.6623Z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.40625"
                        strokeMiterlimit="10"
                      />
                    </g>
                    <g id="g91">
                      <path
                        id="path93"
                        d="M21.3238 19.6623C21.3238 21.6674 19.6983 23.293 17.6932 23.293C15.688 23.293 14.0625 21.6674 14.0625 19.6623C14.0625 17.6572 15.688 16.0317 17.6932 16.0317C19.6983 16.0317 21.3238 17.6572 21.3238 19.6623Z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.40625"
                        strokeMiterlimit="10"
                      />
                    </g>
                    <g id="g95">
                      <path
                        id="path97"
                        d="M10.0312 19.085L10.0942 19.0311C11.2204 18.0686 12.8861 18.0916 13.9852 19.085"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.40625"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                      />
                    </g>
                    <g id="g99">
                      <path
                        id="path101"
                        d="M1.46875 18.7051H2.74783"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.40625"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                      />
                    </g>
                    <g id="g103">
                      <path
                        id="path105"
                        d="M21.2539 18.7051H22.533"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.40625"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_952_6019">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ArrowDownLight = (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.37062 8.63743C2.37062 8.30559 2.43462 8.04012 2.56256 7.70828C2.8825 6.97818 3.58624 6.57996 4.35398 6.57996L11.9036 6.57996C12.6714 6.57996 13.3112 7.04455 13.6951 7.77464C14.015 8.50469 13.951 9.36754 13.4392 9.96485L9.66435 14.8099C9.28045 15.2745 8.76864 15.54 8.12883 15.54C7.55302 15.54 6.97722 15.2745 6.59328 14.8099L2.8185 9.96485C2.49856 9.56664 2.37062 9.102 2.37062 8.63743ZM12.5435 8.30559C12.4795 8.17285 12.2875 7.90738 11.9036 7.90738L4.29005 7.90738C3.90618 7.90738 3.71418 8.17285 3.65024 8.30559C3.52224 8.57106 3.58624 8.9029 3.71418 9.102L7.48902 13.9471C7.61696 14.1462 7.8089 14.2125 8.0009 14.2125C8.19283 14.2125 8.38477 14.1462 8.5127 13.9471L12.2875 9.102C12.6074 8.83653 12.6074 8.50469 12.5435 8.30559Z"
      fill="#0D1421"
    />
    <path
      d="M4.29058 4.66002C4.29058 4.27602 4.54658 4.02002 4.93058 4.02002H11.3306C11.7146 4.02002 11.9706 4.27602 11.9706 4.66002C11.9706 5.04402 11.7146 5.30002 11.3306 5.30002H4.93058C4.54658 5.30002 4.29058 5.04402 4.29058 4.66002Z"
      fill="#0D1421"
    />
    <path
      d="M5.57141 2.10008C5.57141 1.71608 5.82741 1.46008 6.21141 1.46008L10.0514 1.46008C10.4354 1.46008 10.6914 1.71608 10.6914 2.10008C10.6914 2.48408 10.4354 2.74008 10.0514 2.74008H6.21141C5.82741 2.74008 5.57141 2.48408 5.57141 2.10008Z"
      fill="#0D1421"
    />
  </svg>
);

export const ArrowUpLight = (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6294 8.36257C13.6294 8.69441 13.5654 8.95988 13.4374 9.29172C13.1175 10.0218 12.4138 10.42 11.646 10.42H4.09635C3.32859 10.42 2.68879 9.95545 2.30491 9.22536C1.98501 8.49531 2.04899 7.63246 2.56083 7.03515L6.33565 2.19009C6.71955 1.72552 7.23136 1.46004 7.87117 1.46004C8.44698 1.46004 9.02278 1.72552 9.40672 2.19009L13.1815 7.03515C13.5014 7.43336 13.6294 7.898 13.6294 8.36257ZM3.45655 8.69441C3.52053 8.82715 3.71247 9.09262 4.09635 9.09262H11.71C12.0938 9.09262 12.2858 8.82715 12.3498 8.69441C12.4778 8.42894 12.4138 8.0971 12.2858 7.898L8.51098 3.05294C8.38304 2.85384 8.1911 2.78747 7.9991 2.78747C7.80717 2.78747 7.61523 2.85384 7.4873 3.05294L3.71247 7.898C3.39257 8.16347 3.39257 8.49531 3.45655 8.69441Z"
      fill="#0D1421"
    />
    <path
      d="M11.7094 12.34C11.7094 12.724 11.4534 12.98 11.0694 12.98H4.66942C4.28542 12.98 4.02942 12.724 4.02942 12.34C4.02942 11.956 4.28542 11.7 4.66942 11.7H11.0694C11.4534 11.7 11.7094 11.956 11.7094 12.34Z"
      fill="#0D1421"
    />
    <path
      d="M10.4286 14.8999C10.4286 15.2839 10.1726 15.5399 9.78859 15.5399H5.94859C5.56459 15.5399 5.30859 15.2839 5.30859 14.8999C5.30859 14.5159 5.56459 14.2599 5.94859 14.2599H9.78859C10.1726 14.2599 10.4286 14.5159 10.4286 14.8999Z"
      fill="#0D1421"
    />
  </svg>
);

export const UpRightArrow = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="10" fill="#9FE870" />
    <g clipPath="url(#clip0_630_13165)">
      <path
        d="M6.01172 13.6816L12.7617 6.93164"
        stroke="#03000A"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
      <path
        d="M13.3853 11.6138L13.3853 8.71054C13.3853 7.87047 13.3853 7.45043 13.2218 7.12956C13.078 6.84732 12.8486 6.61785 12.5663 6.47404C12.2455 6.31055 11.8254 6.31055 10.9853 6.31055L8.08203 6.31055"
        stroke="#03000A"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_630_13165">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0.703125 1)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const DownRightArrow = (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="20" height="20" rx="10" fill="#F87171" />
    <g clipPath="url(#clip0_630_13177)">
      <path
        d="M6.8125 6.31055L13.5625 13.0605"
        stroke="white"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
      <path
        d="M8.87891 13.6822L11.7822 13.6822C12.6223 13.6822 13.0423 13.6822 13.3632 13.5187C13.6454 13.3749 13.8749 13.1454 14.0187 12.8632C14.1822 12.5423 14.1822 12.1223 14.1822 11.2822V8.37891"
        stroke="white"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_630_13177">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(1.5 1)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ZeroIndicator = (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame 427318646">
      <rect x="0.5" width="20" height="20" rx="10" fill="#60A5FA" />
      <path
        id="Vector"
        d="M15.3008 10L5.30078 10"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const capIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Cap icon (1) 1" clipPath="url(#clip0_952_5149)">
      <g id="Group">
        <g id="Cap">
          <path
            id="Vector"
            d="M9.3407 21.2405C8.02618 21.2401 6.724 20.9872 5.50477 20.4958L1.13417 18.7202C0.206724 18.3464 -0.242056 17.2916 0.131758 16.3641C0.28103 15.9938 0.54857 15.6831 0.892753 15.4806L5.49995 12.7925C5.49995 11.9814 5.53014 9.90773 5.62909 8.30482C5.79564 5.61676 9.36362 2.75977 15.6474 2.75977C21.8032 2.75977 24 6.33258 24 9.67602V14.9109C24.0024 15.6775 23.5349 16.3673 22.8219 16.649L19.5376 17.9574L19.5195 17.9647L13.1609 20.5078C11.9452 20.9908 10.6489 21.2394 9.3407 21.2405ZM6.23385 13.763L1.50473 16.5211C1.3055 16.6393 1.1915 16.8611 1.21142 17.092C1.22459 17.32 1.37 17.5193 1.5832 17.6013L5.95381 19.3757C8.12137 20.2501 10.5428 20.254 12.7131 19.3865L17.3879 17.5181C16.8005 17.2929 16.2322 17.0209 15.6884 16.7045C12.7356 15.1729 9.5345 14.177 6.23385 13.763ZM6.71663 12.6091C10.0665 13.0499 13.3112 14.0831 16.2992 15.6605C17.2056 16.2065 18.2028 16.5855 19.2431 16.7794L22.3814 15.5276C22.6341 15.4274 22.7998 15.1828 22.799 14.9108V9.67602C22.799 6.10082 20.1291 3.9668 15.6534 3.9668C10.3775 3.9668 6.9701 6.26015 6.84217 8.37969C6.74682 9.84018 6.72024 11.7086 6.71181 12.6091H6.71663Z"
            fill="inherit"
          />
          <path
            id="Vector_2"
            d="M19.3351 15.3936H19.3074C18.9744 15.3786 18.7167 15.0965 18.7317 14.7635C18.7667 13.9572 18.821 12.9047 18.8982 11.536C19.2374 5.55635 14.8269 3.96189 14.7823 3.9474C14.467 3.83874 14.2995 3.49506 14.4081 3.17975C14.5168 2.86443 14.8605 2.69691 15.1758 2.80558C15.2301 2.82367 20.4939 4.72354 20.1029 11.6036C20.0268 12.9663 19.9725 14.0176 19.9375 14.8166C19.9232 15.1391 19.6579 15.3933 19.3351 15.3936Z"
            fill="inherit"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_952_5149">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const rocketIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Rocket icon 1" clipPath="url(#clip0_952_5384)">
      <path
        id="Vector"
        d="M23.9719 1.79165C23.9199 0.838307 23.1617 0.0801974 22.2084 0.0281661C20.2847 -0.0769276 16.5205 0.0253068 12.921 1.88704C11.0861 2.83617 9.14546 4.44534 7.59676 6.30196C7.57768 6.32484 7.55912 6.34785 7.54018 6.37078L4.0255 6.64228C3.44697 6.68699 2.93167 6.99023 2.6117 7.47417L0.213855 11.101C-0.0288164 11.468 -0.0673946 11.9273 0.11059 12.3297C0.288621 12.732 0.654434 13.0124 1.0892 13.0798L4.05034 13.5384C4.03989 13.596 4.02939 13.6535 4.01978 13.7111C3.9212 14.3008 4.11657 14.907 4.54248 15.3329L8.66711 19.4576C9.02022 19.8107 9.49736 20.0054 9.98626 20.0054C10.0869 20.0054 10.1882 19.9971 10.289 19.9802C10.3465 19.9706 10.4041 19.9601 10.4616 19.9497L10.9202 22.9109C10.9876 23.3456 11.268 23.7115 11.6703 23.8895C11.8377 23.9635 12.0148 24.0001 12.1912 24.0001C12.4388 24 12.6847 23.9279 12.899 23.7862L16.5258 21.3884C17.0098 21.0683 17.313 20.553 17.3576 19.9746L17.6291 16.4599C17.6521 16.441 17.6751 16.4224 17.698 16.4033C19.5547 14.8546 21.1639 12.914 22.113 11.079C23.9748 7.47946 24.0768 3.71517 23.9719 1.79165ZM15.7503 20.2153L12.281 22.509L11.834 19.6231C13.3003 19.192 14.7507 18.5016 16.1326 17.5766L15.9557 19.8662C15.9447 20.009 15.8698 20.1363 15.7503 20.2153ZM9.66146 18.4632L5.53679 14.3385C5.43156 14.2333 5.3829 14.0854 5.40676 13.9429C5.52939 13.2097 5.71993 12.5116 5.95581 11.8541L12.1446 18.0429C11.3549 18.3258 10.6475 18.4945 10.0571 18.5932C9.9144 18.617 9.7667 18.5684 9.66146 18.4632ZM4.13382 8.04435L6.42339 7.86749C5.49836 9.24932 4.80789 10.6998 4.37678 12.166L1.49096 11.7191L3.78475 8.24976C3.86378 8.13023 3.99104 8.05537 4.13382 8.04435ZM16.7973 15.3234C15.6614 16.2709 14.5588 16.9562 13.5424 17.4521L6.5477 10.4573C7.19729 9.13059 7.99009 8.02579 8.67662 7.20276C10.1098 5.48456 11.8923 4.00232 13.5671 3.13607C16.8706 1.42734 20.3511 1.33532 22.1318 1.43226C22.3675 1.4451 22.555 1.63256 22.5678 1.86829C22.6649 3.64898 22.5727 7.12945 20.8639 10.433C19.9977 12.1077 18.5155 13.8902 16.7973 15.3234Z"
        fill="inherit"
      />
      <path
        id="Vector_2"
        d="M16.4394 11.0736C17.3395 11.0735 18.2399 10.7309 18.9252 10.0456C19.5892 9.38161 19.9548 8.49877 19.9548 7.55977C19.9548 6.62077 19.5892 5.73792 18.9252 5.07394C17.5545 3.70317 15.3242 3.70327 13.9535 5.07394C13.2895 5.73792 12.9238 6.62077 12.9238 7.55977C12.9238 8.49877 13.2895 9.38161 13.9535 10.0456C14.6389 10.731 15.5389 11.0737 16.4394 11.0736ZM14.9478 6.06825C15.359 5.65702 15.8991 5.45142 16.4393 5.45142C16.9795 5.45142 17.5196 5.65702 17.9308 6.06825C18.3292 6.46664 18.5485 6.99633 18.5485 7.55972C18.5485 8.12311 18.3292 8.65284 17.9308 9.05123C17.1084 9.87366 15.7702 9.87361 14.9478 9.05123C14.5494 8.65284 14.3299 8.12316 14.3299 7.55977C14.3299 6.99638 14.5494 6.46664 14.9478 6.06825Z"
        fill="inherit"
      />
      <path
        id="Vector_3"
        d="M0.716773 19.7781C0.896726 19.7781 1.07668 19.7094 1.21393 19.5721L3.50954 17.2765C3.78413 17.0019 3.78413 16.5567 3.50954 16.2821C3.23499 16.0075 2.78977 16.0075 2.51518 16.2821L0.219617 18.5777C-0.0549766 18.8523 -0.0549766 19.2975 0.219617 19.5721C0.356867 19.7094 0.53682 19.7781 0.716773 19.7781Z"
        fill="inherit"
      />
      <path
        id="Vector_4"
        d="M5.61377 18.3856C5.33923 18.111 4.89401 18.111 4.61941 18.3856L0.205945 22.7991C-0.0686484 23.0737 -0.0686484 23.5189 0.205945 23.7935C0.343242 23.9308 0.523148 23.9994 0.703102 23.9994C0.883055 23.9994 1.06301 23.9308 1.20026 23.7935L5.61373 19.38C5.88837 19.1054 5.88837 18.6602 5.61377 18.3856Z"
        fill="inherit"
      />
      <path
        id="Vector_5"
        d="M6.72226 20.4901L4.42665 22.7857C4.15205 23.0603 4.15205 23.5055 4.42665 23.7801C4.56395 23.9174 4.7439 23.9861 4.9238 23.9861C5.10371 23.9861 5.28371 23.9174 5.42096 23.7801L7.71657 21.4845C7.99116 21.2099 7.99116 20.7647 7.71657 20.4901C7.44202 20.2155 6.9968 20.2155 6.72226 20.4901Z"
        fill="inherit"
      />
    </g>
    <defs>
      <clipPath id="clip0_952_5384">
        <rect width="24" height="24" fill="inherit" />
      </clipPath>
    </defs>
  </svg>
);

export const liveIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_1_400)">
      <path
        d="M21.2571 11.2154H2.72296C1.42822 11.2154 0.375 12.2686 0.375 13.5634V21.6522C0.375 22.9468 1.42822 24 2.72296 24H21.2571C22.5518 24 23.605 22.9468 23.605 21.6522V13.5634C23.605 12.2686 22.5518 11.2154 21.2571 11.2154ZM22.1988 21.6522C22.1988 22.1713 21.7764 22.5937 21.2571 22.5937H2.72296C2.20367 22.5937 1.78125 22.1713 1.78125 21.6522V13.5634C1.78125 13.0441 2.20367 12.6216 2.72296 12.6216H21.2571C21.7764 12.6216 22.1988 13.0441 22.1988 13.5634V21.6522Z"
        fill="inherit"
      />
      <path
        d="M11.992 7.53001C12.5507 7.53001 13.1093 7.31779 13.5347 6.89317C13.9472 6.48155 14.1743 5.93406 14.1743 5.35161C14.1743 4.76915 13.9472 4.22166 13.5347 3.81004C12.684 2.96098 11.2999 2.96098 10.4492 3.81004C10.0366 4.22166 9.80957 4.76915 9.80957 5.35161C9.80957 5.93406 10.0366 6.48155 10.4492 6.89317C10.8745 7.31779 11.4332 7.53001 11.992 7.53001ZM11.4425 4.80522C11.5941 4.65398 11.793 4.57854 11.992 4.57854C12.1909 4.57854 12.3897 4.65416 12.5411 4.80522C12.6874 4.95116 12.768 5.14525 12.768 5.35161C12.768 5.55797 12.6874 5.75187 12.5413 5.89799C12.2383 6.2003 11.7455 6.20012 11.4425 5.89799C11.2962 5.75187 11.2158 5.55797 11.2158 5.35161C11.2158 5.14525 11.2964 4.95134 11.4425 4.80522Z"
        fill="inherit"
      />
      <path
        d="M14.5611 8.42632C14.6984 8.56401 14.8786 8.63286 15.0588 8.63286C15.2386 8.63286 15.4182 8.56438 15.5555 8.42742C16.3786 7.60582 16.832 6.5136 16.832 5.35161C16.832 4.18963 16.3786 3.09722 15.5555 2.27581C15.2807 2.00152 14.8354 2.00188 14.5611 2.27673C14.2868 2.55157 14.2873 2.99688 14.5622 3.27117C15.119 3.8269 15.4257 4.56573 15.4257 5.35161C15.4257 6.13732 15.119 6.87633 14.5622 7.43206C14.2873 7.70635 14.2868 8.15148 14.5611 8.42632Z"
        fill="inherit"
      />
      <path
        d="M8.4245 8.42742C8.56183 8.56439 8.74145 8.63287 8.92126 8.63287C9.10144 8.63287 9.28161 8.56402 9.41894 8.42633C9.69324 8.15149 9.69269 7.70636 9.41784 7.43206C8.86102 6.87616 8.55432 6.13733 8.55432 5.35144C8.55432 4.56573 8.86102 3.8269 9.41784 3.271C9.69269 2.9967 9.69324 2.55157 9.41894 2.27673C9.14465 2.00171 8.69934 2.00134 8.4245 2.27563C7.60144 3.09723 7.14825 4.18945 7.14807 5.35144C7.14807 6.51342 7.60144 7.60583 8.4245 8.42742Z"
        fill="inherit"
      />
      <path
        d="M6.48706 19.7801H4.59961V14.7321C4.59961 14.3437 4.28485 14.029 3.89648 14.029C3.50812 14.029 3.19336 14.3437 3.19336 14.7321V20.4833C3.19336 20.8716 3.50812 21.1864 3.89648 21.1864H6.48706C6.87524 21.1864 7.19018 20.8716 7.19018 20.4833C7.19018 20.0951 6.87524 19.7801 6.48706 19.7801Z"
        fill="inherit"
      />
      <path
        d="M8.66553 14.029C8.27716 14.029 7.9624 14.3437 7.9624 14.7321V20.4833C7.9624 20.8716 8.27716 21.1864 8.66553 21.1864C9.05371 21.1864 9.36865 20.8716 9.36865 20.4833V14.7321C9.36865 14.3437 9.05371 14.029 8.66553 14.029Z"
        fill="inherit"
      />
      <path
        d="M14.8146 14.059C14.443 13.9468 14.0505 14.1572 13.9382 14.5289L12.8751 18.0505L11.8118 14.5289C11.6996 14.157 11.3072 13.9468 10.9355 14.059C10.5638 14.1713 10.3534 14.5637 10.4656 14.9354L12.202 20.6865C12.2022 20.6871 12.2024 20.6876 12.2026 20.6882C12.3939 21.3005 13.3365 21.3376 13.5477 20.6882C13.5478 20.6876 13.548 20.6872 13.5482 20.6865L15.2846 14.9354C15.3968 14.5635 15.1863 14.1713 14.8146 14.059Z"
        fill="inherit"
      />
      <path
        d="M20.0836 15.4352C20.4719 15.4352 20.7867 15.1205 20.7867 14.7321C20.7867 14.3437 20.4719 14.029 20.0836 14.029H16.9116C16.5233 14.029 16.2085 14.3437 16.2085 14.7321V20.4833C16.2085 20.8716 16.5233 21.1864 16.9116 21.1864H19.9889C20.3773 21.1864 20.692 20.8716 20.692 20.4833C20.692 20.0951 20.3773 19.7801 19.9889 19.7801H17.6147V17.9487H19.61C19.9984 17.9487 20.3132 17.634 20.3132 17.2456C20.3132 16.8572 19.9984 16.5425 19.61 16.5425H17.6147V15.4352H20.0836Z"
        fill="inherit"
      />
      <path
        d="M17.8753 5.35161C17.8753 6.91936 17.2635 8.39354 16.1526 9.50224C15.8778 9.77653 15.8773 10.2218 16.1515 10.4967C16.2891 10.6342 16.469 10.703 16.6492 10.703C16.829 10.703 17.0087 10.6346 17.146 10.4976C18.5231 9.12322 19.2815 7.29564 19.2815 5.35161C19.2815 3.40777 18.5231 1.58001 17.146 0.20562C16.8711 -0.0686719 16.426 -0.0683056 16.1515 0.206535C15.8773 0.481377 15.8778 0.926689 16.1526 1.20098C17.2635 2.30968 17.8753 3.78368 17.8753 5.35161Z"
        fill="inherit"
      />
      <path
        d="M7.33081 10.7031C7.51098 10.7031 7.69116 10.6342 7.82849 10.4967C8.10278 10.2219 8.10241 9.77654 7.82739 9.50225C6.71649 8.39355 6.10474 6.91937 6.10474 5.35144C6.10474 3.78369 6.71649 2.30951 7.82739 1.20081C8.10223 0.926513 8.10278 0.481201 7.82849 0.206543C7.55401 -0.068481 7.10888 -0.0688472 6.83404 0.205445C5.45691 1.58002 4.69849 3.40759 4.69849 5.35144C4.69849 7.29547 5.45691 9.12304 6.83404 10.4976C6.97137 10.6346 7.151 10.7031 7.33081 10.7031Z"
        fill="inherit"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_400">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const filterIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M3.5 7.5C2.80963 7.5 2.25 6.94037 2.25 6.25V1.25C2.25 0.559625 2.80963 0 3.5 0C4.19037 0 4.75 0.559625 4.75 1.25V6.25C4.75 6.94037 4.19037 7.5 3.5 7.5Z"
      fill="white"
    />
    <path
      d="M18.5 7.5C17.8096 7.5 17.25 6.94037 17.25 6.25V1.25C17.25 0.559625 17.8096 0 18.5 0C19.1904 0 19.75 0.559625 19.75 1.25V6.25C19.75 6.94037 19.1904 7.5 18.5 7.5Z"
      fill="white"
    />
    <path
      d="M11 7.5C8.93225 7.5 7.25 5.81775 7.25 3.75C7.25 1.68225 8.93225 0 11 0C13.0677 0 14.75 1.68225 14.75 3.75C14.75 5.81775 13.0677 7.5 11 7.5ZM11 2.5C10.3108 2.5 9.75 3.06075 9.75 3.75C9.75 4.43925 10.3108 5 11 5C11.6892 5 12.25 4.43925 12.25 3.75C12.25 3.06075 11.6892 2.5 11 2.5Z"
      fill="white"
    />
    <path
      d="M26 7.5C23.9323 7.5 22.25 5.81775 22.25 3.75C22.25 1.68225 23.9323 0 26 0C28.0677 0 29.75 1.68225 29.75 3.75C29.75 5.81775 28.0677 7.5 26 7.5ZM26 2.5C25.3108 2.5 24.75 3.06075 24.75 3.75C24.75 4.43925 25.3108 5 26 5C26.6892 5 27.25 4.43925 27.25 3.75C27.25 3.06075 26.6892 2.5 26 2.5Z"
      fill="white"
    />
    <path
      d="M16 32H13.5C12.8096 32 12.25 31.4404 12.25 30.75V25.8211C12.25 25.4872 12.12 25.1732 11.8839 24.9372L3.34838 16.4017C2.64006 15.6934 2.25 14.7517 2.25 13.75C2.25 11.6823 3.93225 10 6 10H26C28.0677 10 29.75 11.6823 29.75 13.75C29.75 14.7517 29.3599 15.6934 28.6516 16.4017L20.1161 24.9372C19.88 25.1733 19.75 25.4872 19.75 25.8211V28.25C19.75 30.3177 18.0677 32 16 32ZM14.75 29.5H16C16.6892 29.5 17.25 28.9392 17.25 28.25V25.8211C17.25 24.8194 17.6401 23.8777 18.3484 23.1694L26.8839 14.6339C27.12 14.3977 27.25 14.0839 27.25 13.75C27.25 13.0608 26.6892 12.5 26 12.5H6C5.31075 12.5 4.75 13.0608 4.75 13.75C4.75 14.0839 4.88 14.3978 5.11613 14.6339L13.6516 23.1694C14.3599 23.8777 14.75 24.8194 14.75 25.8211V29.5Z"
      fill="white"
    />
  </svg>
);

export const stockUp = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
  >
    <g clipPath="url(#clip0_1_195)">
      <path
        d="M5.65683 6.34316C2.53769 9.4623 2.5378 14.5376 5.65699 17.6568C8.77613 20.7759 13.8514 20.776 16.9705 17.6569C20.0897 14.5377 20.0896 9.4624 16.9705 6.34326C13.8513 3.22407 8.77598 3.22402 5.65683 6.34316ZM16.1962 16.8825C13.504 19.5746 9.12357 19.5746 6.43132 16.8824C3.73911 14.1902 3.73906 9.80979 6.43121 7.11754C9.12341 4.42544 13.5039 4.42549 16.1961 7.11774C18.8882 9.80984 18.8883 14.1903 16.1962 16.8825Z"
        fill="#21CD9D"
      />
      <path
        d="M9.65045 8.81751C9.34808 8.81756 9.10296 9.06278 9.10291 9.36505C9.10291 9.66757 9.34802 9.91269 9.6506 9.91264L12.6262 9.91259L8.31815 14.2215C8.10437 14.4354 8.10437 14.782 8.31831 14.9959C8.53219 15.2097 8.87875 15.2096 9.09258 14.9958L13.4008 10.6868L13.4007 13.6631C13.4007 13.9655 13.6459 14.2107 13.9483 14.2106C14.0995 14.2106 14.2364 14.1494 14.3355 14.0502C14.4346 13.9512 14.4958 13.8143 14.4959 13.6631L14.496 9.36495C14.496 9.21972 14.4384 9.08049 14.3356 8.97776C14.2329 8.87507 14.0937 8.81746 13.9483 8.81736L9.65045 8.81751Z"
        fill="#21CD9D"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_195">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(22.6274 12) rotate(135)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const stockDown = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
  >
    <g clipPath="url(#clip0_1_205)">
      <path
        d="M16.9703 5.97059C13.8511 2.85144 8.77587 2.85155 5.65668 5.97074C2.53754 9.08988 2.53744 14.1652 5.65658 17.2843C8.77572 20.4034 13.851 20.4034 16.9702 17.2842C20.0894 14.165 20.0894 9.08973 16.9703 5.97059ZM6.43096 16.5099C3.73881 13.8178 3.73886 9.43732 6.43101 6.74507C9.12321 4.05287 13.5037 4.05281 16.1959 6.74496C18.888 9.43716 18.888 13.8176 16.1957 16.5099C13.5036 19.202 9.1231 19.2021 6.43096 16.5099Z"
        fill="#E44C4B"
      />
      <path
        d="M14.496 9.96426C14.4959 9.66189 14.2507 9.41677 13.9485 9.41672C13.6459 9.41672 13.4008 9.66184 13.4009 9.96441L13.4009 12.94L9.09203 8.63197C8.87814 8.41819 8.53153 8.41819 8.3176 8.63212C8.10382 8.846 8.10387 9.19256 8.3177 9.4064L12.6268 13.7146L9.65046 13.7145C9.34804 13.7145 9.10282 13.9597 9.10287 14.2621C9.10292 14.4133 9.16415 14.5502 9.26327 14.6493C9.36234 14.7484 9.49925 14.8096 9.6504 14.8097L13.9486 14.8098C14.0938 14.8098 14.233 14.7522 14.3358 14.6494C14.4384 14.5467 14.496 14.4075 14.4961 14.2621L14.496 9.96426Z"
        fill="#E44C4B"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_205">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(11.3135 22.9412) rotate(-135)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const stockNormal = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <g clipPath="url(#clip0_1_285)">
      <path
        d="M8.31346 0.0194702C3.90233 0.0194702 0.313646 3.6083 0.313646 8.01951C0.313646 12.4306 3.90233 16.0195 8.31346 16.0195C12.7246 16.0195 16.3134 12.4306 16.3134 8.01951C16.3134 3.6083 12.7246 0.0194702 8.31346 0.0194702ZM8.31346 14.9243C4.50619 14.9243 1.40878 11.8269 1.40871 8.01951C1.40871 4.21216 4.50612 1.11468 8.31346 1.1146C12.1207 1.11468 15.2181 4.21216 15.2181 8.01958C15.2181 11.8268 12.1207 14.9243 8.31346 14.9243Z"
        fill="#4AB8F7"
      />
      <path
        d="M9.38778 4.59306C9.17394 4.37929 8.82722 4.37937 8.61345 4.59306C8.39953 4.80698 8.39953 5.15363 8.61352 5.36754L10.7176 7.47159L4.62453 7.47217C4.32212 7.47225 4.07703 7.71734 4.07703 8.01989C4.07711 8.32229 4.3222 8.56731 4.6246 8.56731L10.7179 8.56673L8.6133 10.6712C8.39946 10.8851 8.39946 11.2318 8.6133 11.4456C8.72026 11.5525 8.86036 11.606 9.00054 11.606C9.14065 11.606 9.28075 11.5525 9.38771 11.4457L12.427 8.40647C12.5297 8.30382 12.5874 8.16459 12.5874 8.0193C12.5873 7.87402 12.5297 7.73486 12.4269 7.63199L9.38778 4.59306Z"
        fill="#4AB8F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_285">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="matrix(-1 0 0 -1 16.3135 16.0195)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const crossIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_1_675)">
      <path
        d="M20.4853 3.51469C18.2188 1.24823 15.2053 0 12 0C8.79469 0 5.78123 1.24823 3.51473 3.51469C1.24823 5.78123 0 8.79469 0 12C0 15.2053 1.24823 18.2188 3.51473 20.4853C5.78123 22.7518 8.79469 24 12 24C14.4194 24 16.7515 23.283 18.7443 21.9267C19.1723 21.6354 19.2831 21.0523 18.9918 20.6242C18.7005 20.1962 18.1173 20.0853 17.6893 20.3768C16.0088 21.5205 14.0415 22.125 12 22.125C6.41705 22.125 1.875 17.583 1.875 12C1.875 6.41705 6.41705 1.875 12 1.875C17.583 1.875 22.125 6.41705 22.125 12C22.125 13.8637 21.6147 15.6849 20.6492 17.2667C20.3795 17.7087 20.5191 18.2856 20.961 18.5554C21.4029 18.8252 21.9799 18.6855 22.2497 18.2436C23.3948 16.3675 24 14.2085 24 12C24 8.79469 22.7518 5.78123 20.4853 3.51469Z"
        fill="inherit"
      />
      <path
        d="M15.862 8.13816C15.4959 7.77202 14.9023 7.77202 14.5362 8.13816L12.0002 10.6741L9.46423 8.13816C9.09809 7.77202 8.50452 7.77202 8.13842 8.13816C7.77233 8.5043 7.77228 9.09793 8.13842 9.46402L10.6744 12L8.13837 14.536C7.77223 14.9021 7.77223 15.4958 8.13837 15.8618C8.32142 16.0449 8.56133 16.1364 8.80128 16.1364C9.04123 16.1364 9.28114 16.0449 9.46419 15.8618L12.0002 13.3259L14.5362 15.8618C14.7193 16.0449 14.9592 16.1364 15.1991 16.1364C15.4391 16.1364 15.679 16.0449 15.862 15.8618C16.2282 15.4957 16.2282 14.9021 15.862 14.536L13.3261 12L15.8621 9.46402C16.2282 9.09793 16.2282 8.5043 15.862 8.13816Z"
        fill="inherit"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_675">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const badgeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_1_616)">
      <path
        d="M7.0415 16.7311V20.3655C7.0415 20.3655 7.0415 23.7984 7.0415 24C7.16446 23.9385 7.4184 23.8115 7.74983 23.6458C7.95944 23.5411 8.20002 23.4208 8.45807 23.2917L8.68246 20.0871L8.45807 17.0276L7.74979 16.8067L7.0415 16.7311Z"
        fill="#FF4D4D"
      />
      <path
        d="M15.541 23.2917C15.7991 23.4207 16.0397 23.541 16.2493 23.6459C16.5805 23.8115 16.8344 23.9385 16.9576 24C16.9576 23.7984 16.9576 22.082 16.9576 20.3657C16.9576 18.6493 16.9576 16.9329 16.9576 16.7313L16.2493 16.8069L15.541 17.0277L15.1987 20.0871L15.541 23.2917Z"
        fill="#CC295F"
      />
      <path
        d="M12.7082 19.9682L11.9999 18.4154L9.16678 16.9579L8.4585 17.0276V23.2917L11.9999 21.521L12.7082 19.9682Z"
        fill="#FF884D"
      />
      <path
        d="M14.8326 16.9579L11.9995 18.4154V19.9682V21.5209C12.4018 21.7221 14.2055 22.6239 15.5409 23.2917V17.0276L14.8326 16.9579Z"
        fill="#FF4D4D"
      />
      <path
        d="M8.75926 1.3846C6.21279 1.32454 4.11811 3.41038 4.17662 5.96729C2.33357 7.72789 2.32734 10.6816 4.17662 12.4481C4.11844 14.992 6.19584 17.0888 8.75926 17.0308C9.59791 17.9088 10.7565 18.4154 11.9997 18.4154L12.708 9.20769L11.9997 0C10.7561 0 9.59768 0.506848 8.75926 1.3846Z"
        fill="#FEDE51"
      />
      <path
        d="M15.24 17.0308C17.7903 17.0887 19.8811 15.0043 19.8226 12.4481C21.6655 10.6879 21.6724 7.73417 19.8226 5.96724C19.8811 3.41515 17.7927 1.32487 15.2399 1.3846C14.4013 0.506612 13.2426 0 11.9995 0V18.4154C13.243 18.4154 14.4015 17.9085 15.24 17.0308Z"
        fill="#FEBD4E"
      />
      <path
        d="M9.36942 2.85811C9.36338 2.85745 8.96877 2.81566 8.98624 2.8175C7.04318 2.61111 5.4028 4.24507 5.60933 6.19441C5.60999 6.20045 5.65178 6.59506 5.64994 6.57759C5.64012 6.58548 5.3305 6.83583 5.35029 6.81982C4.23054 7.72501 3.90072 9.26336 4.50762 10.5315C4.89529 11.3416 5.48576 11.6819 5.64994 11.8377C5.64928 11.8438 5.60749 12.2384 5.60933 12.2209C5.45762 13.6528 6.31214 14.9737 7.638 15.4413C8.48496 15.74 9.1431 15.5632 9.36942 15.5573L9.49054 15.7071C9.54607 15.7526 10.3232 16.9988 11.9995 16.9988L12.7078 9.20768L11.9995 1.41656C11.5337 1.41656 11.0832 1.52078 10.6757 1.71574C9.86555 2.10346 9.52524 2.69388 9.36942 2.85811Z"
        fill="#FEBD4E"
      />
      <path
        d="M14.3873 15.8569C14.3953 15.8471 14.6455 15.5375 14.6296 15.5573C14.6356 15.5579 15.0302 15.5997 15.0127 15.5978C16.9616 15.8045 18.5957 14.1656 18.3897 12.2209C18.389 12.2148 18.3473 11.8202 18.3491 11.8377C18.3589 11.8298 18.6686 11.5795 18.6488 11.5954C19.7694 10.6895 20.0979 9.15097 19.4915 7.88381C19.1038 7.07367 18.5134 6.73346 18.3491 6.57759C18.3498 6.57155 18.3915 6.17694 18.3897 6.19441C18.5415 4.76141 17.6859 3.44117 16.361 2.97394C15.514 2.67523 14.8559 2.85216 14.6296 2.85806L14.5085 2.70824C14.4529 2.66281 13.6758 1.41656 11.9995 1.41656V16.9988C12.9291 16.9988 13.7999 16.5836 14.3873 15.8569Z"
        fill="#FD9F4B"
      />
      <path
        d="M11.1087 8.17958C10.4121 8.28082 9.81332 8.36779 9.1167 8.46903C9.62076 8.96039 10.054 9.38267 10.5581 9.87403C10.4391 10.5679 10.3368 11.1641 10.2178 11.858C10.8409 11.5304 11.3764 11.2489 11.9995 10.9213L12.7078 9.16683L11.9995 6.37454C11.688 7.00581 11.4202 7.54831 11.1087 8.17958Z"
        fill="#FF884D"
      />
      <path
        d="M13.4409 9.87403C13.945 9.38267 14.3783 8.96039 14.8823 8.46903C14.1857 8.36779 13.587 8.28082 12.8903 8.17958C12.5788 7.54831 12.311 7.00581 11.9995 6.37454V10.9213C12.6226 11.2489 13.1581 11.5304 13.7812 11.858C13.6622 11.1641 13.5599 10.5679 13.4409 9.87403Z"
        fill="#FF4D4D"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_616">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const bullIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <g clipPath="url(#clip0_1_1244)">
      <path
        d="M15.7045 10.9186C15.4163 10.8604 15.3209 10.4425 15.3281 10.1028C15.3359 9.70894 15.4758 9.46101 15.7135 9.42139C15.9272 9.38837 16.1331 9.39317 16.3288 9.42079C16.279 9.21188 16.216 9.02278 16.1361 8.8763C15.8654 8.37803 15.4127 8.44107 14.8923 7.86596C13.6604 6.50263 11.8402 4.3733 10.5543 4.43393C8.72817 4.51917 2.61691 7.40131 2.30714 7.52438C1.99798 7.64744 0.83876 7.0117 0.821951 6.6365C0.804542 6.2601 1.55614 5.25277 2.08562 5.16812C2.61511 5.08228 3.69028 5.20234 3.98084 5.04806C4.27139 4.89438 4.664 4.26284 4.664 4.0065C4.664 3.75076 3.98084 3.22128 3.98084 3.22128C3.98084 3.22128 3.7245 2.79385 3.38292 2.81066C3.04133 2.82867 2.58029 3.2549 2.27292 3.22128C2.35817 3.54546 3.04133 3.88704 3.32769 3.87263C3.61344 3.85942 3.9118 3.59768 3.9118 3.59768C3.9118 3.59768 4.16814 3.69914 4.30501 3.90505C4.40046 4.04792 4.23657 4.40031 3.96343 4.55339C3.68908 4.70768 2.4098 4.46875 1.91333 4.58821C1.41747 4.70708 -0.0671233 6.12563 0.00131321 6.70494C0.0691494 7.28605 1.58856 8.61816 2.15166 8.72142C1.77646 9.52224 2.16907 11.4691 1.99918 11.606C1.82809 11.7428 1.17914 11.4 1.03867 11.7446C0.897591 12.0892 1.82809 13.7737 1.69121 13.9964C1.55434 14.2179 1.57835 14.7234 1.57835 14.7234L3.02272 14.7132C3.00592 14.2696 2.61811 13.9796 2.61811 13.9796L2.4146 13.0899C2.4146 13.0899 3.48377 12.5268 3.82535 11.9794C3.92801 12.2531 4.40646 12.7484 4.61117 12.8174C4.81588 12.8864 4.20175 12.9543 4.2984 13.2298C4.39446 13.5066 6.64386 14.32 6.68048 14.4785C6.42234 14.8837 6.60844 15.1574 6.60844 15.1574L7.89072 15.1905C7.73704 14.3038 7.07789 14.0198 7.07789 14.0198L6.02433 12.8654C6.02433 12.8654 7.05387 11.6918 7.15353 10.4984C7.83369 11.3706 9.30988 11.5201 9.30988 11.5201C9.30988 11.5201 8.19628 14.1951 8.12184 14.3716C8.0486 14.5475 8.28333 15.1905 8.28333 15.1905H9.68328C9.59863 14.8561 8.88005 14.3698 8.88005 14.3698L10.8275 11.4973L11.3234 11.4895C11.3234 11.4895 11.8696 13.8433 11.7676 14.0649C11.6649 14.2864 11.6811 14.9185 11.6811 14.9185L13.1159 14.8837C13.0811 14.4227 12.6381 14.1327 12.6381 14.1327L12.6711 11.4685C12.6711 11.4685 13.4581 11.726 13.8867 11.4505C13.73 11.9313 13.6286 13.0587 13.7144 13.2959C13.8003 13.533 14.1058 13.6897 14.346 13.6554C14.5849 13.6206 16.0022 12.085 16.2766 11.6C16.3654 11.4433 16.4201 11.1755 16.4423 10.8622C16.351 10.8694 16.2586 10.8796 16.1697 10.8946C15.9824 10.9228 15.8246 10.9426 15.7045 10.9186Z"
        fill="#21CD9D"
      />
      <path
        d="M17.368 10.0511C16.9244 9.74369 16.3541 9.52697 15.746 9.62482C15.4362 9.67345 15.4896 10.6658 15.746 10.7174C16.0023 10.769 16.4976 10.5457 16.9418 10.7006C17.3848 10.8537 18.0002 11.5543 18.0002 11.3327C17.9996 11.1118 17.8117 10.3596 17.368 10.0511Z"
        fill="#21CD9D"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_1244">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const bearIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
  >
    <g clipPath="url(#clip0_1_1254)">
      <path
        d="M0.773043 12.6942C0.901821 12.2837 1.49619 11.6839 1.42395 10.8824C1.35171 10.0812 0.714699 8.2508 0.880032 7.46953C1.04536 6.68825 1.87442 4.39125 4.01795 4.04387C6.16055 3.69662 7.69943 4.27304 8.52125 4.23605C9.34248 4.19892 9.49189 3.57798 10.3997 3.58601C11.5715 3.59687 11.7733 4.08324 12.6017 4.34413C13.2092 4.53559 15.1118 4.53328 15.1118 4.53328C15.1118 4.53328 15.6562 3.82301 15.8221 4.08324C15.988 4.34362 16.2011 5.00669 16.2011 5.00669C16.2011 5.00669 17.2195 5.36175 17.3138 5.55162C17.4082 5.74149 17.5378 6.04936 17.5378 6.04936C17.5378 6.04936 18.6163 6.3329 18.7345 6.59328C18.8527 6.85351 18.2607 7.46888 18.0714 7.68256C17.8821 7.89618 15.6801 7.94294 15.3311 8.20006C14.9823 8.45754 14.0053 8.65075 13.4597 8.74441C12.4358 8.92068 11.9858 10.9546 11.7255 13.2042C12.0335 13.465 12.578 13.6959 12.6074 14.4142H9.26937C9.26937 14.4142 9.225 13.9347 9.16839 13.3409C9.11265 12.7471 8.10292 10.4994 8.10292 10.4994C8.10292 10.4994 7.36927 11.0678 6.87176 11.0922C6.91852 11.5418 6.70874 12.0201 6.70874 12.0201C6.70874 12.0201 6.27905 12.5361 5.86137 12.9445C6.626 13.2599 6.6037 13.816 6.6037 13.816L3.7701 13.838C3.7701 13.838 3.48612 13.2466 3.48612 12.7726C3.10638 13.3176 2.37273 13.5306 2.37273 13.5306L2.82906 14.4142H1.09756C1.09647 14.4136 0.644194 13.1044 0.773043 12.6942ZM16.6882 6.17307C16.8128 6.17307 16.9131 6.07209 16.9131 5.94809C16.9131 5.82438 16.8128 5.72296 16.6882 5.72296C16.5644 5.72296 16.4631 5.8238 16.4631 5.94809C16.4631 6.07325 16.5649 6.17307 16.6882 6.17307Z"
        fill="#FF90A4"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_1254">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="matrix(-1 0 0 1 18.75 0)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const announceIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_1_1272)">
      <path
        d="M12.4282 2.97786C11.6281 2.17674 10.4785 1.92389 9.4585 2.2318L13.174 5.94833C13.4822 4.93061 13.2332 3.78177 12.4282 2.97786Z"
        fill="#4AB8F7"
      />
      <path
        d="M15.2679 9.36817L6.03959 0.137357C5.91952 0.0172946 5.74396 -0.0285179 5.58052 0.0177008C5.41712 0.0639196 5.29149 0.194888 5.25212 0.360076L3.76074 6.61623L8.78984 11.6453L15.045 10.1556C15.2102 10.1162 15.3412 9.99064 15.3874 9.82726C15.4336 9.66386 15.388 9.48826 15.2679 9.36817Z"
        fill="#4AB8F7"
      />
      <path
        d="M8.38116 12.5642L6.3916 14.5525L7.70032 15.8626C7.78823 15.9506 7.90754 16.0001 8.03191 16.0001C8.66785 16.0001 9.23679 15.6206 9.48198 15.0319C9.72451 14.4433 9.59051 13.7732 9.1406 13.3245L8.38116 12.5642Z"
        fill="#4AB8F7"
      />
      <path
        d="M3.50498 7.68677C3.0942 8.09777 1.47013 9.7228 1.47013 9.7228C0.305633 10.8858 0.302977 12.7707 1.46966 13.9359C2.63313 15.1012 4.52023 15.1003 5.68254 13.9361C5.68254 13.9361 7.30632 12.3134 7.71907 11.9008L3.50498 7.68677Z"
        fill="#4AB8F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_1272">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const glassesIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M13.8469 4.82165V4.81775H4.055V4.82349C1.84632 4.88408 0 6.73423 0 9.00145C0 11.3068 1.88166 13.1823 4.18694 13.1823C6.15834 13.1823 7.82038 11.8103 8.2591 9.97135H9.76535C10.2041 11.8103 11.86 13.1823 13.8314 13.1823C16.1368 13.1823 17.9999 11.3067 17.9999 9.00145C18 6.70956 16.1292 4.84322 13.8469 4.82165ZM4.19312 11.7098C2.69975 11.7098 1.48475 10.4948 1.48475 9.00145C1.48475 7.50808 2.69975 6.29308 4.19312 6.29308C5.68649 6.29308 6.90149 7.50808 6.90149 9.00145C6.90149 10.4948 5.68649 11.7098 4.19312 11.7098ZM13.8315 11.7098C12.3381 11.7098 11.1231 10.4948 11.1231 9.00145C11.1231 7.50808 12.3381 6.29308 13.8315 6.29308C15.3248 6.29308 16.5398 7.50808 16.5398 9.00145C16.5398 10.4948 15.3248 11.7098 13.8315 11.7098Z"
      fill="#0000FF"
    />
    <path
      d="M4.11939 7.01233C3.10369 7.01233 2.27734 7.83867 2.27734 8.8543C2.27734 9.13893 2.50808 9.36966 2.7927 9.36966C3.07733 9.36966 3.30806 9.13893 3.30806 8.8543C3.30806 8.40704 3.67198 8.04305 4.11939 8.04305C4.40402 8.04305 4.63475 7.81232 4.63475 7.52769C4.63475 7.24306 4.40402 7.01233 4.11939 7.01233Z"
      fill="#0000FF"
    />
    <path
      d="M13.6847 7.01233C12.6691 7.01233 11.8428 7.83867 11.8428 8.8543C11.8428 9.13893 12.0735 9.36966 12.3581 9.36966C12.6428 9.36966 12.8735 9.13893 12.8735 8.8543C12.8735 8.40704 13.2374 8.04305 13.6847 8.04305C13.9694 8.04305 14.2001 7.81232 14.2001 7.52769C14.2001 7.24306 13.9694 7.01233 13.6847 7.01233Z"
      fill="#0000FF"
    />
  </svg>
);

export const searchIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_1_1630)">
      <path
        d="M23.7267 22.4071L17.8695 16.5501C19.3254 14.7993 20.2025 12.5512 20.2025 10.1016C20.2025 4.53154 15.6711 0 10.1013 0C4.53141 0 0 4.53154 0 10.1016C0 15.6712 4.53141 20.2024 10.1013 20.2024C12.5508 20.2024 14.7991 19.3254 16.5498 17.8695L22.4071 23.7267C22.5893 23.9089 22.8281 24 23.0669 24C23.3056 24 23.5445 23.9089 23.7268 23.7267C24.0912 23.3623 24.0912 22.7715 23.7267 22.4071ZM1.86621 10.1016C1.86621 5.56057 5.56044 1.86621 10.1013 1.86621C14.6421 1.86621 18.3362 5.56057 18.3362 10.1016C18.3362 14.6422 14.6421 18.3362 10.1013 18.3362C5.56044 18.3362 1.86621 14.6422 1.86621 10.1016Z"
        fill="inherit"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_1630">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const lightIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_102_1078)">
      <path
        d="M12.046 3.34473L11.9951 3.34491C10.1302 3.35804 8.37162 4.09549 7.04313 5.42135C5.7146 6.74726 4.97373 8.50443 4.95704 10.3692C4.93922 12.3599 5.76612 14.2783 7.22569 15.6323C7.74012 16.1095 8.0352 16.7774 8.0352 17.4645V21.3018H9.46874V21.4227C9.46874 22.8439 10.6249 24 12.0461 24C13.4672 24 14.6234 22.8439 14.6234 21.4227V21.3018H16.0569V17.4559C16.0569 16.7713 16.346 16.1122 16.85 15.6475C18.3023 14.3087 19.1354 12.4084 19.1354 10.434C19.1353 6.52499 15.9551 3.34473 12.046 3.34473ZM13.2168 21.4227C13.2168 22.0683 12.6916 22.5935 12.046 22.5935C11.4004 22.5935 10.8751 22.0683 10.8751 21.4227V21.3017H13.2168V21.4227H13.2168ZM9.4416 19.8953V18.1677H14.6504V19.8953H9.4416ZM15.8966 14.6134C15.2771 15.1845 14.8643 15.9429 14.7139 16.7612H12.7492V14.3153L14.6607 13.0859V10.9691H13.2542V12.3183L12.046 13.0954L10.8378 12.3183V10.9691H9.43138V13.0859L11.3428 14.3153V16.7612H9.37615C9.22304 15.9427 8.80649 15.1803 8.18217 14.6012C7.01205 13.5157 6.3491 11.9778 6.3634 10.3818C6.39101 7.29887 8.92182 4.77307 12.0049 4.75132L12.046 4.75118C15.1795 4.75118 17.7288 7.30046 17.7288 10.434C17.7289 12.0167 17.061 13.54 15.8966 14.6134Z"
        fill="inherit"
      />
      <path d="M11.2967 0H12.7032V1.9003H11.2967V0Z" fill="inherit" />
      <path
        d="M6.17131 1.74512L7.3893 1.04189L8.34189 2.69178L7.1239 3.395L6.17131 1.74512Z"
        fill="inherit"
      />
      <path
        d="M2.60793 5.82324L3.31115 4.60526L4.96103 5.55784L4.25781 6.77583L2.60793 5.82324Z"
        fill="inherit"
      />
      <path
        d="M1.56104 9.73047H3.46621V11.1369H1.56104V9.73047Z"
        fill="inherit"
      />
      <path
        d="M20.5337 9.73047H22.4389V11.1369H20.5337V9.73047Z"
        fill="inherit"
      />
      <path
        d="M19.0383 5.55762L20.6882 4.60501L21.3914 5.82299L19.7415 6.7756L19.0383 5.55762Z"
        fill="inherit"
      />
      <path
        d="M15.6577 2.69238L16.6103 1.0425L17.8283 1.74572L16.8757 3.39561L15.6577 2.69238Z"
        fill="inherit"
      />
    </g>
    <defs>
      <clipPath id="clip0_102_1078">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const informationIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_102_1088)">
      <path
        d="M12 0C5.36761 0 0 5.367 0 12C0 18.6323 5.367 24 12 24C18.6324 24 24 18.633 24 12C24 5.3677 18.633 0 12 0ZM12 22.3256C6.30647 22.3256 1.67442 17.6936 1.67442 12C1.67442 6.30642 6.30647 1.67442 12 1.67442C17.6935 1.67442 22.3256 6.30642 22.3256 12C22.3256 17.6936 17.6935 22.3256 12 22.3256Z"
        fill="inherit"
      />
      <path
        d="M12.0003 10.0029C11.2895 10.0029 10.784 10.3031 10.784 10.7454V16.7635C10.784 17.1426 11.2895 17.5216 12.0003 17.5216C12.6795 17.5216 13.2323 17.1426 13.2323 16.7635V10.7453C13.2323 10.3031 12.6795 10.0029 12.0003 10.0029Z"
        fill="inherit"
      />
      <path
        d="M12.0003 6.29102C11.2737 6.29102 10.7051 6.81227 10.7051 7.4125C10.7051 8.01278 11.2737 8.54983 12.0003 8.54983C12.7111 8.54983 13.2798 8.01278 13.2798 7.4125C13.2798 6.81227 12.7111 6.29102 12.0003 6.29102Z"
        fill="inherit"
      />
    </g>
    <defs>
      <clipPath id="clip0_102_1088">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const briefcaseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_102_1098)">
      <path
        d="M21.8594 4.81634H16.4852L16.2189 2.98774C16.1024 2.18805 15.4051 1.58496 14.597 1.58496H9.40311C8.59494 1.58496 7.89767 2.18805 7.78119 2.98784L7.51489 4.81634H2.14067C0.960312 4.81634 3.05176e-05 5.77662 3.05176e-05 6.95693V20.2751C3.05176e-05 21.4555 0.960312 22.4158 2.14067 22.4158H21.8594C23.0397 22.4158 24 21.4555 24 20.2751V6.95693C24 5.77662 23.0397 4.81634 21.8594 4.81634ZM9.17825 3.19127C9.19437 3.08037 9.29108 2.99674 9.40316 2.99674H14.597C14.7091 2.99674 14.8058 3.08041 14.822 3.19127L15.0586 4.81634H8.94158L9.17825 3.19127ZM22.5883 20.2752C22.5883 20.6771 22.2613 21.0041 21.8594 21.0041H2.14067C1.73876 21.0041 1.41176 20.6771 1.41176 20.2751V13.5465C2.03295 14.0318 2.81347 14.3221 3.66106 14.3221H9.17637V15.0123C9.17637 15.273 9.32005 15.5125 9.55006 15.6351L11.6678 16.7645C11.7717 16.8199 11.8858 16.8476 12 16.8476C12.1142 16.8476 12.2284 16.8199 12.3322 16.7645L14.45 15.6351C14.68 15.5124 14.8237 15.273 14.8237 15.0123V14.3221H20.339C21.1865 14.3221 21.9671 14.0318 22.5883 13.5465V20.2752ZM10.5882 14.5887V12.5496H13.412V14.5887L12 15.3417L10.5882 14.5887ZM22.5883 10.661C22.5883 11.9013 21.5793 12.9103 20.339 12.9103H14.8237V11.8436C14.8237 11.4538 14.5077 11.1378 14.1178 11.1378H9.88227C9.49245 11.1378 9.17637 11.4538 9.17637 11.8436V12.9103H3.66106C2.4208 12.9104 1.41176 11.9014 1.41176 10.6611V6.95693C1.41176 6.60527 1.66212 6.31099 1.99391 6.24293C2.0413 6.23318 2.09037 6.22812 2.14062 6.22812H21.8594C21.9096 6.22812 21.9587 6.23323 22.0061 6.24293C22.3379 6.31104 22.5882 6.60532 22.5882 6.95693V10.661H22.5883Z"
        fill="inherit"
      />
    </g>
    <defs>
      <clipPath id="clip0_102_1098">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const controlsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_110_2153)">
      <path
        d="M23.2969 2.8125H19.6636C19.337 1.20975 17.9166 0 16.2188 0C14.5209 0 13.1005 1.20975 12.7739 2.8125H0.703125C0.314812 2.8125 0 3.12731 0 3.51562C0 3.90394 0.314812 4.21875 0.703125 4.21875H12.7739C13.1005 5.8215 14.5209 7.03125 16.2188 7.03125C17.9166 7.03125 19.337 5.8215 19.6636 4.21875H23.2969C23.6852 4.21875 24 3.90394 24 3.51562C24 3.12731 23.6852 2.8125 23.2969 2.8125ZM16.2188 5.625C15.0558 5.625 14.1097 4.67906 14.1094 3.51623C14.1094 3.51605 14.1094 3.51586 14.1094 3.51562C14.1094 3.51539 14.1094 3.5152 14.1094 3.51502C14.1097 2.35219 15.0558 1.40625 16.2188 1.40625C17.3819 1.40625 18.3281 2.35252 18.3281 3.51562C18.3281 4.67873 17.3819 5.625 16.2188 5.625Z"
        fill="inherit"
      />
      <path
        d="M23.2969 11.2969H11.2261C10.8995 9.69412 9.47906 8.48438 7.78125 8.48438C6.08344 8.48438 4.66303 9.69412 4.33636 11.2969H0.703125C0.314812 11.2969 0 11.6117 0 12C0 12.3883 0.314812 12.7031 0.703125 12.7031H4.33636C4.66298 14.3059 6.08344 15.5156 7.78125 15.5156C9.47906 15.5156 10.8995 14.3059 11.2261 12.7031H23.2969C23.6852 12.7031 24 12.3883 24 12C24 11.6117 23.6852 11.2969 23.2969 11.2969ZM7.78125 14.1094C6.61833 14.1094 5.6722 13.1634 5.67188 12.0006C5.67188 12.0004 5.67192 12.0002 5.67192 12C5.67192 11.9998 5.67188 11.9996 5.67188 11.9994C5.6722 10.8366 6.61833 9.89062 7.78125 9.89062C8.94436 9.89062 9.89062 10.8369 9.89062 12C9.89062 13.1631 8.94436 14.1094 7.78125 14.1094Z"
        fill="inherit"
      />
      <path
        d="M23.2969 19.7812H19.6636C19.337 18.1785 17.9166 16.9688 16.2188 16.9688C14.5209 16.9688 13.1005 18.1785 12.7739 19.7812H0.703125C0.314812 19.7812 0 20.0961 0 20.4844C0 20.8727 0.314812 21.1875 0.703125 21.1875H12.7739C13.1005 22.7902 14.5209 24 16.2188 24C17.9166 24 19.337 22.7902 19.6636 21.1875H23.2969C23.6852 21.1875 24 20.8727 24 20.4844C24 20.0961 23.6852 19.7812 23.2969 19.7812ZM16.2188 22.5938C15.0558 22.5938 14.1097 21.6478 14.1094 20.485C14.1094 20.4848 14.1094 20.4846 14.1094 20.4844C14.1094 20.4841 14.1094 20.484 14.1094 20.4838C14.1097 19.3209 15.0558 18.375 16.2188 18.375C17.3819 18.375 18.3281 19.3213 18.3281 20.4844C18.3281 21.6475 17.3819 22.5938 16.2188 22.5938Z"
        fill="inherit"
      />
    </g>
    <defs>
      <clipPath id="clip0_110_2153">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const intersectIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_102_1112)">
      <path
        d="M-0.654939 16.6215L0.118136 18.3297L10.0204 13.8483C10.1783 14.013 10.3587 14.1609 10.5609 14.2871C11.5978 14.934 12.8969 14.8206 13.8028 14.0997L21.8935 19.1475L22.886 17.5567L14.7953 12.5089C14.8571 12.2286 14.8752 11.9431 14.8509 11.6622L24.7543 7.18029L23.9812 5.47208L14.079 9.95351C13.921 9.78888 13.7406 9.64091 13.5384 9.51474C12.5015 8.86781 11.2025 8.98124 10.2966 9.70214L2.52399 4.85283L1.5315 6.44361L9.30406 11.2929C9.24228 11.5732 9.22418 11.8587 9.24848 12.1396L-0.654939 16.6215ZM11.2543 11.4047C11.5279 10.9661 12.1073 10.8319 12.5459 11.1055C12.9845 11.3792 13.1187 11.9586 12.8451 12.3972C12.5714 12.8357 11.992 12.9699 11.5534 12.6963C11.1148 12.4227 10.9806 11.8432 11.2543 11.4047Z"
        fill="inherit"
      />
    </g>
    <defs>
      <clipPath id="clip0_102_1112">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const crossCircleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <g clipPath="url(#clip0_102_1216)">
      <path d="M2.05867 11.9411C2.70012 12.5826 3.44733 13.0863 4.2796 13.4383C5.14181 13.803 6.05707 13.9879 7 13.9879C7.9429 13.9879 8.85818 13.803 9.72039 13.4383C10.5526 13.0863 11.2999 12.5825 11.9413 11.9411C12.5828 11.2997 13.0865 10.5525 13.4385 9.72018C13.8032 8.85798 13.9881 7.94269 13.9881 6.99981C13.9881 6.05686 13.8032 5.1416 13.4385 4.27942C13.0865 3.44715 12.5828 2.69994 11.9413 2.05848C11.2999 1.41703 10.5527 0.913309 9.72039 0.561303C8.85816 0.196604 7.9429 0.0117188 7 0.0117188C6.05707 0.0117188 5.14181 0.196628 4.2796 0.561303C3.44733 0.913309 2.70012 1.41705 2.05867 2.05848C1.41721 2.69992 0.913492 3.44715 0.561462 4.2794C0.196811 5.1416 0.0119019 6.05686 0.0119019 6.99981C0.0119019 7.94272 0.196811 8.85798 0.561486 9.72018C0.913492 10.5525 1.41724 11.2997 2.05867 11.9411ZM7 1.03187C10.296 1.03187 12.9679 3.70381 12.9679 6.99981C12.9679 10.2958 10.296 12.9677 7 12.9677C3.70399 12.9677 1.03206 10.2958 1.03206 6.99981C1.03206 3.70381 3.70399 1.03187 7 1.03187Z" />
      <path d="M7 14C6.0554 14 5.1386 13.8147 4.27496 13.4495C3.44126 13.0968 2.69277 12.5922 2.05027 11.9497C1.40772 11.3072 0.903138 10.5586 0.550537 9.72499C0.185219 8.86131 0 7.94448 0 7C0 6.0555 0.185219 5.13864 0.550513 4.27494C0.903114 3.44129 1.40772 2.69279 2.05024 2.05024C2.69277 1.40769 3.44129 0.903114 4.27494 0.550513C5.13864 0.185219 6.05547 0 6.99998 0C7.94455 0 8.86138 0.185219 9.72499 0.550537C10.5587 0.903138 11.3072 1.40774 11.9497 2.05027C12.5923 2.69286 13.0969 3.44136 13.4495 4.27496C13.8148 5.13867 14 6.0555 14 7C14 7.94448 13.8148 8.86131 13.4495 9.72501C13.0969 10.5586 12.5923 11.3071 11.9497 11.9498C11.3072 12.5922 10.5587 13.0968 9.72499 13.4495C8.86138 13.8147 7.94455 14 7 14ZM7 0.0238132C6.05869 0.0238132 5.145 0.208389 4.28425 0.572445C3.45343 0.923856 2.70746 1.42672 2.0671 2.06708C1.42672 2.70746 0.923856 3.45341 0.572445 4.2842C0.208389 5.14498 0.0238132 6.05869 0.0238132 7C0.0238132 7.94126 0.208389 8.855 0.572445 9.71575C0.923856 10.5466 1.42672 11.2925 2.0671 11.9329C2.70744 12.5732 3.45339 13.0761 4.28425 13.4275C5.14491 13.7916 6.05862 13.9761 7 13.9761C7.94138 13.9761 8.85507 13.7916 9.71575 13.4275C10.5466 13.0761 11.2926 12.5732 11.9329 11.9329C12.5733 11.2924 13.0761 10.5465 13.4275 9.71575C13.7916 8.855 13.9762 7.94129 13.9762 7C13.9762 6.05869 13.7916 5.14498 13.4275 4.28425C13.0762 3.45348 12.5733 2.70753 11.9329 2.0671C11.2925 1.42674 10.5465 0.92388 9.71575 0.572469C8.85505 0.208389 7.94133 0.0238132 7 0.0238132ZM7 12.9798C5.40273 12.9798 3.90105 12.3578 2.77161 11.2284C1.64218 10.0989 1.02016 8.59727 1.02016 7C1.02016 5.40273 1.64216 3.90105 2.77161 2.77161C3.90105 1.64218 5.40273 1.02016 7 1.02016C8.59727 1.02016 10.0989 1.64218 11.2284 2.77161C12.3578 3.90107 12.9798 5.40273 12.9798 7C12.9798 8.59727 12.3578 10.0989 11.2284 11.2284C10.0989 12.3578 8.59724 12.9798 7 12.9798ZM7 1.04397C5.40909 1.04397 3.91341 1.66352 2.78845 2.78845C1.66352 3.91341 1.04397 5.40909 1.04397 7C1.04397 8.59091 1.66352 10.0866 2.78845 11.2115C3.91338 12.3364 5.40909 12.956 7 12.956C8.59091 12.956 10.0866 12.3364 11.2115 11.2115C12.3365 10.0866 12.956 8.59089 12.956 7C12.956 5.40909 12.3365 3.91338 11.2115 2.78845C10.0866 1.66349 8.59091 1.04397 7 1.04397Z" />
      <path d="M4.40354 9.59619C4.50315 9.69583 4.63367 9.74562 4.76422 9.74562C4.89476 9.74562 5.0253 9.69581 5.12489 9.59619L6.99999 7.7211L8.87511 9.59619C8.97469 9.69583 9.10524 9.74562 9.23578 9.74562C9.36632 9.74562 9.49684 9.69581 9.59645 9.59619C9.79565 9.39705 9.79565 9.07407 9.59645 8.87487L7.72131 6.99977L9.59641 5.12465C9.7956 4.92546 9.7956 4.60248 9.59641 4.4033C9.39726 4.20411 9.07428 4.20411 8.87508 4.4033L6.99996 6.27842L5.12487 4.4033C4.92567 4.20411 4.60269 4.20411 4.40352 4.4033C4.20432 4.6025 4.20432 4.92546 4.40352 5.12465L6.27864 6.99977L4.40352 8.87487C4.20434 9.07407 4.20434 9.39705 4.40354 9.59619Z" />
      <path d="M9.2358 9.75775C9.09635 9.75775 8.96528 9.70345 8.86669 9.60482L7 7.73813L5.13334 9.60482C5.03475 9.70345 4.90366 9.75775 4.76423 9.75775C4.62481 9.75775 4.49372 9.70345 4.39513 9.60482C4.29654 9.50623 4.24225 9.37516 4.24225 9.23576C4.24225 9.09633 4.29654 8.96527 4.39513 8.86666L6.26182 6.99997L4.39513 5.13328C4.19162 4.92975 4.19162 4.5986 4.39513 4.39507C4.49372 4.29648 4.62478 4.24219 4.76423 4.24219C4.90366 4.24219 5.03475 4.29648 5.13334 4.39507L7.00003 6.26176L8.86672 4.39507C8.96533 4.29648 9.0964 4.24219 9.23582 4.24219C9.37522 4.24219 9.50629 4.29648 9.60488 4.39507C9.70349 4.49365 9.75776 4.62475 9.75776 4.76417C9.75776 4.9036 9.70349 5.03469 9.60488 5.13328L7.73819 6.99997L9.60493 8.86666C9.70354 8.96527 9.75783 9.09633 9.75783 9.23576C9.75783 9.37516 9.70354 9.50623 9.60493 9.60482C9.50627 9.70343 9.3752 9.75775 9.2358 9.75775ZM7 7.70446L8.88353 9.58798C8.97759 9.68209 9.10271 9.73393 9.2358 9.73393C9.36884 9.73393 9.49396 9.68209 9.58807 9.58798C9.68215 9.49392 9.73399 9.36883 9.73399 9.23576C9.73399 9.10269 9.68215 8.97758 9.58807 8.88349L7.70449 6.99997L9.58802 5.11644C9.68211 5.02235 9.73392 4.89724 9.73392 4.76417C9.73392 4.6311 9.68211 4.50601 9.58802 4.41193C9.49396 4.31784 9.36887 4.26602 9.2358 4.26602C9.10273 4.26602 8.97762 4.31784 8.88353 4.41193L7 6.29545L5.11648 4.41193C5.02239 4.31784 4.89728 4.26602 4.76421 4.26602C4.63114 4.26602 4.50605 4.31784 4.41196 4.41193C4.21774 4.60617 4.21774 4.9222 4.41196 5.11644L6.29549 6.99997L4.41196 8.88349C4.31788 8.97758 4.26606 9.10269 4.26606 9.23576C4.26606 9.36883 4.31788 9.49392 4.41196 9.58798C4.50607 9.68209 4.63117 9.73393 4.76423 9.73393C4.8973 9.73393 5.02239 9.68209 5.1165 9.58798L7 7.70446Z" />
    </g>
    <defs>
      <clipPath id="clip0_102_1216">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const chartIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path d="M4.14218 8.61726H3.12592V4.24763C3.12592 3.85928 2.81108 3.54443 2.42273 3.54443C2.03438 3.54443 1.71954 3.85928 1.71954 4.24763V8.61726H0.703192C0.314843 8.61726 0 8.93211 0 9.32046V14.5934C0 14.9817 0.314843 15.2966 0.703192 15.2966H1.71954V16.313C1.71954 16.7013 2.03438 17.0162 2.42273 17.0162C2.81108 17.0162 3.12592 16.7013 3.12592 16.313V15.2966H4.14222C4.53057 15.2966 4.84542 14.9817 4.84542 14.5934V9.32046C4.84537 8.93211 4.53057 8.61726 4.14218 8.61726ZM3.43899 13.8902H1.40638V10.0236H3.43899V13.8902Z" />
    <path d="M10.527 13.8332H9.51069V12.8167C9.51069 12.4284 9.19585 12.1135 8.8075 12.1135C8.41915 12.1135 8.10431 12.4284 8.10431 12.8167V13.8332H7.08796C6.69961 13.8332 6.38477 14.148 6.38477 14.5364V17.9752C6.38477 18.3636 6.69961 18.6784 7.08796 18.6784H8.10431V19.7522C8.10431 20.1405 8.41915 20.4554 8.8075 20.4554C9.19585 20.4554 9.51069 20.1405 9.51069 19.7522V18.6784H10.527C10.9153 18.6784 11.2302 18.3636 11.2302 17.9752V14.5364C11.2302 14.148 10.9153 13.8332 10.527 13.8332ZM9.8238 17.2721H7.7912V15.2396H9.8238V17.2721Z" />
    <path d="M16.912 10.3937H15.8957V9.37726C15.8957 8.98891 15.5809 8.67407 15.1925 8.67407C14.8042 8.67407 14.4893 8.98891 14.4893 9.37726V10.3937H13.473C13.0846 10.3937 12.7698 10.7085 12.7698 11.0969V14.5357C12.7698 14.9241 13.0846 15.2389 13.473 15.2389H14.4893V19.7519C14.4893 20.1403 14.8041 20.4551 15.1925 20.4551C15.5808 20.4551 15.8957 20.1403 15.8957 19.7519V15.2389H16.912C17.3003 15.2389 17.6151 14.9241 17.6151 14.5357V11.0969C17.6152 10.7085 17.3003 10.3937 16.912 10.3937ZM16.2088 13.8326H14.1762V11.8H16.2088V13.8326Z" />
    <path d="M23.2968 5.26407H22.2804V4.24763C22.2804 3.85928 21.9656 3.54443 21.5772 3.54443C21.1889 3.54443 20.874 3.85928 20.874 4.24763V5.26407H19.8577C19.4694 5.26407 19.1545 5.57891 19.1545 5.96726V11.0972C19.1545 11.4856 19.4694 11.8004 19.8577 11.8004H20.874V14.5934C20.874 14.9818 21.1889 15.2966 21.5772 15.2966C21.9656 15.2966 22.2804 14.9818 22.2804 14.5934V11.8004H23.2968C23.6851 11.8004 24 11.4856 24 11.0972V5.96726C24 5.57891 23.6851 5.26407 23.2968 5.26407ZM22.5936 10.394H20.561V6.67045H22.5936V10.394Z" />
  </svg>
);

export const arrowLeftIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_120_321)">
      <path d="M12.0001 24C18.6168 24 23.9998 18.6168 23.9998 11.9999C23.9998 5.38325 18.6168 0 12.0001 0C5.38338 0 0.000244141 5.38325 0.000244141 11.9999C0.000244141 18.6168 5.38338 24 12.0001 24ZM12.0001 1.6427C17.711 1.6427 22.3571 6.28892 22.3572 11.9999C22.3572 17.711 17.7111 22.3572 12.0001 22.3573C6.28917 22.3572 1.64306 17.711 1.64306 11.9998C1.64306 6.28903 6.28917 1.6427 12.0001 1.6427Z" />
      <path d="M10.3885 17.1395C10.7093 17.4602 11.2294 17.4601 11.55 17.1395C11.8709 16.8187 11.8709 16.2987 11.5499 15.9778L8.39375 12.8218L17.5334 12.8209C17.987 12.8208 18.3547 12.4531 18.3547 11.9993C18.3546 11.5457 17.9869 11.1782 17.5333 11.1782L8.39331 11.1791L11.5503 8.02233C11.871 7.70156 11.871 7.18137 11.5503 6.86072C11.3898 6.70039 11.1797 6.62012 10.9694 6.62012C10.7592 6.62012 10.5491 6.70039 10.3887 6.86061L5.82971 11.4194C5.67563 11.5734 5.58911 11.7823 5.58911 12.0002C5.58922 12.2181 5.67574 12.4269 5.82982 12.5812L10.3885 17.1395Z" />
    </g>
    <defs>
      <clipPath id="clip0_120_321">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const refreshIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 24 24"
    id="refresh"
  >
    <path fill="none" d="M0 0h24v24H0V0z"></path>
    <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"></path>
  </svg>
);

export const infoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_64_150)">
      <path d="M12 0C5.36761 0 0 5.367 0 12C0 18.6323 5.367 24 12 24C18.6324 24 24 18.633 24 12C24 5.3677 18.633 0 12 0ZM12 22.3256C6.30647 22.3256 1.67442 17.6936 1.67442 12C1.67442 6.30642 6.30647 1.67442 12 1.67442C17.6935 1.67442 22.3256 6.30642 22.3256 12C22.3256 17.6936 17.6935 22.3256 12 22.3256Z" />
      <path d="M12.0003 10.0029C11.2895 10.0029 10.7841 10.3031 10.7841 10.7454V16.7635C10.7841 17.1426 11.2895 17.5216 12.0003 17.5216C12.6795 17.5216 13.2323 17.1426 13.2323 16.7635V10.7453C13.2323 10.3031 12.6795 10.0029 12.0003 10.0029Z" />
      <path d="M12.0003 6.29102C11.2737 6.29102 10.7051 6.81227 10.7051 7.4125C10.7051 8.01278 11.2737 8.54983 12.0003 8.54983C12.7111 8.54983 13.2798 8.01278 13.2798 7.4125C13.2798 6.81227 12.711 6.29102 12.0003 6.29102Z" />
    </g>
    <defs>
      <clipPath id="clip0_64_150">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const closeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_72_117)">
      <path
        d="M3.52925 20.4709C4.62889 21.5705 5.90982 22.434 7.33657 23.0375C8.81463 23.6627 10.3836 23.9796 12.0001 23.9796C13.6165 23.9796 15.1856 23.6627 16.6636 23.0375C18.0903 22.434 19.3713 21.5705 20.471 20.4709C21.5706 19.3713 22.4341 18.0903 23.0375 16.6636C23.6627 15.1855 23.9797 13.6165 23.9797 12.0001C23.9797 10.3836 23.6627 8.81459 23.0375 7.33657C22.4341 5.90982 21.5705 4.62889 20.471 3.52925C19.3713 2.42961 18.0904 1.56609 16.6636 0.962652C15.1855 0.337454 13.6165 0.0205078 12.0001 0.0205078C10.3836 0.0205078 8.81463 0.337495 7.33657 0.962652C5.90982 1.56609 4.62889 2.42965 3.52925 3.52925C2.42961 4.62885 1.56609 5.90982 0.962611 7.33653C0.337495 8.81459 0.0205078 10.3836 0.0205078 12.0001C0.0205078 13.6165 0.337495 15.1855 0.962652 16.6636C1.56609 18.0903 2.42965 19.3713 3.52925 20.4709ZM12.0001 1.76935C17.6504 1.76935 22.2308 6.3498 22.2308 12.0001C22.2308 17.6503 17.6504 22.2308 12.0001 22.2308C6.3498 22.2308 1.76935 17.6503 1.76935 12.0001C1.76935 6.3498 6.3498 1.76935 12.0001 1.76935Z"
        fill="inherit"
      />
      <path
        d="M12 23.9999C10.3807 23.9999 8.80902 23.6824 7.32851 23.0562C5.89931 22.4517 4.61618 21.5867 3.51474 20.4853C2.41323 19.3837 1.54824 18.1005 0.943777 16.6714C0.317518 15.1908 0 13.6191 0 12C0 10.3809 0.317518 8.8091 0.943736 7.32847C1.5482 5.89935 2.41323 4.61622 3.5147 3.5147C4.61618 2.41319 5.89935 1.5482 7.32847 0.943736C8.8091 0.317518 10.3808 0 12 0C13.6192 0 15.1909 0.317518 16.6714 0.943777C18.1006 1.54824 19.3837 2.41327 20.4853 3.51474C21.5868 4.61634 22.4518 5.89947 23.0562 7.32851C23.6825 8.80914 24 10.3809 24 12C24 13.6191 23.6825 15.1908 23.0562 16.6714C22.4518 18.1005 21.5869 19.3837 20.4853 20.4853C19.3838 21.5867 18.1006 22.4517 16.6714 23.0563C15.1909 23.6824 13.6192 23.9999 12 23.9999ZM12 0.0408226C10.3863 0.0408226 8.82 0.357238 7.34443 0.981334C5.92017 1.58375 4.64136 2.4458 3.5436 3.54356C2.4458 4.64136 1.58375 5.92013 0.981334 7.34435C0.357238 8.81996 0.0408226 10.3863 0.0408226 12C0.0408226 13.6136 0.357238 15.18 0.981334 16.6556C1.58375 18.0798 2.4458 19.3586 3.5436 20.4564C4.64132 21.5541 5.92009 22.4161 7.34443 23.0186C8.81984 23.6427 10.3862 23.9591 12 23.9591C13.6138 23.9591 15.1801 23.6427 16.6556 23.0186C18.0799 22.4161 19.3587 21.5541 20.4564 20.4564C21.5542 19.3585 22.4162 18.0797 23.0186 16.6556C23.6427 15.18 23.9592 13.6136 23.9592 12C23.9592 10.3863 23.6427 8.81996 23.0186 7.34443C22.4163 5.92025 21.5542 4.64149 20.4564 3.5436C19.3586 2.44584 18.0798 1.58379 16.6556 0.981375C15.1801 0.357238 13.6137 0.0408226 12 0.0408226ZM12 22.2511C9.26183 22.2511 6.68751 21.1848 4.75134 19.2486C2.81517 17.3124 1.74884 14.7382 1.74884 12C1.74884 9.26183 2.81512 6.68751 4.75134 4.75134C6.68751 2.81517 9.26183 1.74884 12 1.74884C14.7382 1.74884 17.3124 2.81517 19.2486 4.75134C21.1848 6.68755 22.2511 9.26183 22.2511 12C22.2511 14.7382 21.1848 17.3124 19.2486 19.2486C17.3124 21.1848 14.7381 22.2511 12 22.2511ZM12 1.78966C9.27273 1.78966 6.7087 2.85174 4.7802 4.7802C2.85174 6.7087 1.78966 9.27273 1.78966 12C1.78966 14.7273 2.85174 17.2913 4.7802 19.2197C6.70866 21.1482 9.27273 22.2103 12 22.2103C14.7273 22.2103 17.2913 21.1482 19.2198 19.2197C21.1482 17.2913 22.2103 14.7272 22.2103 12C22.2103 9.27273 21.1482 6.70866 19.2198 4.7802C17.2913 2.8517 14.7273 1.78966 12 1.78966Z"
        fill="inherit"
      />
      <path
        d="M7.54912 16.4507C7.71988 16.6215 7.94363 16.7069 8.16742 16.7069C8.39121 16.7069 8.615 16.6215 8.78572 16.4507L12.0002 13.2362L15.2147 16.4507C15.3854 16.6215 15.6092 16.7069 15.833 16.7069C16.0567 16.7069 16.2805 16.6215 16.4513 16.4507C16.7927 16.1093 16.7927 15.5556 16.4513 15.2141L13.2367 11.9997L16.4512 8.78519C16.7927 8.44371 16.7927 7.89003 16.4512 7.54859C16.1098 7.20711 15.5561 7.20711 15.2146 7.54859L12.0001 10.7631L8.78568 7.54859C8.4442 7.20711 7.89052 7.20711 7.54908 7.54859C7.2076 7.89007 7.2076 8.44371 7.54908 8.78519L10.7636 11.9997L7.54908 15.2141C7.20764 15.5556 7.20764 16.1093 7.54912 16.4507Z"
        fill="inherit"
      />
      <path
        d="M15.8328 16.7277C15.5938 16.7277 15.3691 16.6346 15.2001 16.4655L12 13.2655L8.80004 16.4655C8.63104 16.6346 8.40631 16.7277 8.16729 16.7277C7.92828 16.7277 7.70355 16.6346 7.53454 16.4655C7.36554 16.2965 7.27246 16.0718 7.27246 15.8329C7.27246 15.5939 7.36554 15.3692 7.53454 15.2001L10.7346 12.0001L7.53454 8.80004C7.18567 8.45113 7.18567 7.88345 7.53454 7.53454C7.70355 7.36554 7.92823 7.27246 8.16729 7.27246C8.40631 7.27246 8.63104 7.36554 8.80004 7.53454L12.0001 10.7346L15.2001 7.53454C15.3692 7.36554 15.5939 7.27246 15.8329 7.27246C16.0718 7.27246 16.2965 7.36554 16.4655 7.53454C16.6346 7.70355 16.7276 7.92828 16.7276 8.16729C16.7276 8.40631 16.6346 8.63104 16.4655 8.80004L13.2655 12.0001L16.4656 15.2001C16.6347 15.3692 16.7277 15.5939 16.7277 15.8329C16.7277 16.0718 16.6347 16.2965 16.4656 16.4655C16.2965 16.6346 16.0718 16.7277 15.8328 16.7277ZM12 13.2078L15.2289 16.4367C15.3902 16.598 15.6047 16.6869 15.8328 16.6869C16.0609 16.6869 16.2754 16.598 16.4367 16.4367C16.598 16.2754 16.6869 16.061 16.6869 15.8329C16.6869 15.6048 16.598 15.3903 16.4367 15.229L13.2077 12.0001L16.4366 8.77118C16.5979 8.60989 16.6868 8.39541 16.6868 8.16729C16.6868 7.93918 16.5979 7.72473 16.4366 7.56344C16.2754 7.40215 16.0609 7.31332 15.8328 7.31332C15.6047 7.31332 15.3902 7.40215 15.2289 7.56344L12 10.7923L8.77114 7.56344C8.60985 7.40215 8.39537 7.31332 8.16725 7.31332C7.93913 7.31332 7.72469 7.40215 7.5634 7.56344C7.23045 7.89643 7.23045 8.43819 7.5634 8.77118L10.7923 12.0001L7.5634 15.229C7.40211 15.3903 7.31328 15.6048 7.31328 15.8329C7.31328 16.061 7.40211 16.2754 7.5634 16.4367C7.72473 16.598 7.93918 16.6869 8.16729 16.6869C8.39541 16.6869 8.60985 16.598 8.77118 16.4367L12 13.2078Z"
        fill="inherit"
      />
    </g>
    <defs>
      <clipPath id="clip0_72_117">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const clock = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
  >
    <path
      d="M3.73078 6.94609C4.04831 6.94609 4.36774 6.83907 4.63064 6.61977L8.44903 3.43552C9.04549 2.93813 9.12579 2.05135 8.6284 1.45489C8.13101 0.858431 7.24423 0.778064 6.64777 1.27552L2.82937 4.45991C2.23291 4.9573 2.15262 5.84408 2.65001 6.44054C2.92816 6.77396 3.32796 6.94609 3.73078 6.94609Z"
      fill="inherit"
    />
    <path
      d="M27.5513 3.4365L31.3697 6.62074C31.6327 6.84004 31.952 6.94706 32.2695 6.94706C32.6724 6.94706 33.0722 6.77493 33.3503 6.44144C33.8477 5.84498 33.7674 4.9582 33.171 4.46081L29.3526 1.27649C28.7561 0.779104 27.8693 0.859331 27.3719 1.45586C26.8745 2.05232 26.9548 2.93903 27.5513 3.4365Z"
      fill="inherit"
    />
    <path
      d="M29.7337 7.67264C26.9166 4.85557 23.2648 3.177 19.3362 2.86601V1.40625C19.3362 0.629578 18.7066 0 17.9299 0C17.1533 0 16.5237 0.629578 16.5237 1.40625V2.8781C12.6485 3.21764 9.05024 4.88925 6.26678 7.67271C3.1326 10.8068 1.40649 14.9738 1.40649 19.4061C1.40649 23.8384 3.1326 28.0055 6.2667 31.1396C6.55738 31.4303 6.85705 31.7087 7.16488 31.9749L6.03411 33.8742C5.63685 34.5416 5.85573 35.4047 6.52306 35.8019C6.74863 35.9362 6.99641 36 7.2411 36C7.72049 36 8.18771 35.7547 8.45075 35.3129L9.44989 33.6345C12.005 35.1762 14.9393 35.9998 18.0002 35.9998C21.0489 35.9998 23.9747 35.1856 26.5489 33.6319L27.5496 35.3128C27.8126 35.7547 28.2798 35.9999 28.7592 35.9999C29.0039 35.9999 29.2518 35.9361 29.4773 35.8019C30.1446 35.4046 30.3635 34.5415 29.9662 33.8742L28.2084 30.9215C28.0054 30.5804 27.6677 30.341 27.2786 30.2624C26.8897 30.1839 26.4854 30.2732 26.1659 30.5087C23.7878 32.2611 20.9641 33.1873 18.0002 33.1873C10.4012 33.1873 4.21899 27.0051 4.21899 19.4061C4.21899 11.8071 10.4012 5.625 18.0002 5.625C25.5991 5.625 31.7813 11.8072 31.7813 19.4062C31.7813 21.7273 31.1939 24.0214 30.0825 26.0405C29.708 26.7209 29.956 27.5761 30.6365 27.9506C31.3168 28.325 32.172 28.077 32.5465 27.3966C33.8859 24.9631 34.5938 22.2 34.5938 19.4061C34.5938 14.9738 32.8678 10.8068 29.7337 7.67264Z"
      fill="inherit"
    />
    <path
      d="M17.9297 9.07031C17.153 9.07031 16.5234 9.69989 16.5234 10.4766V19.4062C16.5234 19.7792 16.6716 20.1369 16.9353 20.4006L20.9128 24.378C21.1873 24.6525 21.5472 24.7899 21.9071 24.7899C22.2671 24.7899 22.6269 24.6525 22.9015 24.378C23.4507 23.8289 23.4507 22.9385 22.9015 22.3893L19.3359 18.8237V10.4766C19.3359 9.69989 18.7064 9.07031 17.9297 9.07031Z"
      fill="inherit"
    />
  </svg>
);

export const mike = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_670_3823)">
      <path
        d="M12.375 6H10.6562V4.59375C10.6562 3.12909 9.46466 1.9375 8 1.9375C6.53534 1.9375 5.34375 3.12909 5.34375 4.59375V6H3.625C3.36612 6 3.15625 6.20988 3.15625 6.46875V8.34375C3.15625 10.8565 5.07953 12.9282 7.53125 13.1648V15.0625H6.35938C6.1005 15.0625 5.89062 15.2724 5.89062 15.5312C5.89062 15.7901 6.1005 16 6.35938 16H9.64062C9.8995 16 10.1094 15.7901 10.1094 15.5312C10.1094 15.2724 9.8995 15.0625 9.64062 15.0625H8.46875V13.1648C10.9205 12.9282 12.8438 10.8565 12.8438 8.34375V6.46875C12.8438 6.20988 12.6339 6 12.375 6ZM6.28125 4.59375C6.28125 3.64603 7.05228 2.875 8 2.875C8.94772 2.875 9.71875 3.64603 9.71875 4.59375V8.34375C9.71875 9.29147 8.94772 10.0625 8 10.0625C7.05228 10.0625 6.28125 9.29147 6.28125 8.34375V4.59375ZM11.9062 8.34375C11.9062 10.4977 10.1539 12.25 8 12.25C5.84609 12.25 4.09375 10.4977 4.09375 8.34375V6.9375H5.34375V8.34375C5.34375 9.80841 6.53534 11 8 11C9.46466 11 10.6562 9.80841 10.6562 8.34375V6.9375H11.9062V8.34375Z"
        fill="#0000FF"
      />
      <path
        d="M11.7812 3.58887C12.0401 3.58887 12.25 3.379 12.25 3.12012C12.25 2.86123 12.0401 2.65137 11.7812 2.65137C11.5224 2.65137 11.3125 2.86123 11.3125 3.12012C11.3125 3.379 11.5224 3.58887 11.7812 3.58887Z"
        fill="#0000FF"
      />
      <path
        d="M13.4385 1.46248C13.2555 1.27945 12.9587 1.27942 12.7756 1.46248C12.5925 1.64554 12.5925 1.94232 12.7756 2.12539C13.3239 2.67367 13.3239 3.56586 12.7756 4.11414C12.5925 4.2972 12.5925 4.59398 12.7756 4.77704C12.8671 4.86857 12.9871 4.91432 13.107 4.91432C13.227 4.91432 13.347 4.86854 13.4385 4.77701C14.3523 3.8632 14.3523 2.37632 13.4385 1.46248Z"
        fill="#0000FF"
      />
      <path
        d="M14.7643 0.137297C14.5813 -0.0457656 14.2845 -0.0457656 14.1014 0.137297C13.9184 0.320359 13.9184 0.617141 14.1014 0.800203C14.7212 1.41995 15.0625 2.24392 15.0625 3.12039C15.0625 3.99686 14.7212 4.82086 14.1014 5.44061C13.9184 5.62364 13.9184 5.92045 14.1014 6.10352C14.193 6.19505 14.3129 6.24083 14.4329 6.24083C14.5528 6.24083 14.6728 6.19505 14.7643 6.10352C15.5612 5.30667 16 4.24727 16 3.12039C16 1.99352 15.5612 0.934109 14.7643 0.137297Z"
        fill="#0000FF"
      />
      <path
        d="M4.21875 3.58887C4.47763 3.58887 4.6875 3.379 4.6875 3.12012C4.6875 2.86123 4.47763 2.65137 4.21875 2.65137C3.95987 2.65137 3.75 2.86123 3.75 3.12012C3.75 3.379 3.95987 3.58887 4.21875 3.58887Z"
        fill="#0000FF"
      />
      <path
        d="M3.2244 4.11413C2.67612 3.56584 2.67612 2.67366 3.2244 2.12537C3.40746 1.94231 3.40746 1.64553 3.2244 1.46247C3.04137 1.27944 2.74456 1.27944 2.5615 1.46247C1.64771 2.37631 1.64771 3.86319 2.5615 4.77703C2.65303 4.86856 2.773 4.91434 2.89293 4.91434C3.01287 4.91434 3.13287 4.86856 3.22437 4.77706C3.40746 4.594 3.40746 4.29719 3.2244 4.11413Z"
        fill="#0000FF"
      />
      <path
        d="M0.9375 3.12038C0.9375 2.24394 1.27881 1.41994 1.89856 0.800191C2.08162 0.61716 2.08162 0.320348 1.89856 0.137285C1.71556 -0.0457461 1.41875 -0.0457773 1.23566 0.137285C0.438844 0.934098 0 1.9935 0 3.12038C0 4.24725 0.438844 5.30666 1.23566 6.10347C1.32719 6.195 1.44716 6.24079 1.56709 6.24079C1.68703 6.24079 1.80703 6.19503 1.89853 6.10347C2.08159 5.92041 2.08159 5.62363 1.89853 5.44057C1.27881 4.82082 0.9375 3.99685 0.9375 3.12038Z"
        fill="#0000FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_670_3823">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const calendar = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_670_3793)">
      <path
        d="M12.0625 7.1875C12.4077 7.1875 12.6875 6.90768 12.6875 6.5625C12.6875 6.21732 12.4077 5.9375 12.0625 5.9375C11.7173 5.9375 11.4375 6.21732 11.4375 6.5625C11.4375 6.90768 11.7173 7.1875 12.0625 7.1875Z"
        fill="#0000FF"
      />
      <path
        d="M13.5 1.25H12.6875V0.625C12.6875 0.279813 12.4077 0 12.0625 0C11.7173 0 11.4375 0.279813 11.4375 0.625V1.25H8.59375V0.625C8.59375 0.279813 8.31394 0 7.96875 0C7.62356 0 7.34375 0.279813 7.34375 0.625V1.25H4.53125V0.625C4.53125 0.279813 4.25144 0 3.90625 0C3.56106 0 3.28125 0.279813 3.28125 0.625V1.25H2.5C1.1215 1.25 0 2.3715 0 3.75V13.5C0 14.8785 1.1215 16 2.5 16H7.28125C7.62644 16 7.90625 15.7202 7.90625 15.375C7.90625 15.0298 7.62644 14.75 7.28125 14.75H2.5C1.81075 14.75 1.25 14.1892 1.25 13.5V3.75C1.25 3.06075 1.81075 2.5 2.5 2.5H3.28125V3.125C3.28125 3.47019 3.56106 3.75 3.90625 3.75C4.25144 3.75 4.53125 3.47019 4.53125 3.125V2.5H7.34375V3.125C7.34375 3.47019 7.62356 3.75 7.96875 3.75C8.31394 3.75 8.59375 3.47019 8.59375 3.125V2.5H11.4375V3.125C11.4375 3.47019 11.7173 3.75 12.0625 3.75C12.4077 3.75 12.6875 3.47019 12.6875 3.125V2.5H13.5C14.1892 2.5 14.75 3.06075 14.75 3.75V7.3125C14.75 7.65769 15.0298 7.9375 15.375 7.9375C15.7202 7.9375 16 7.65769 16 7.3125V3.75C16 2.3715 14.8785 1.25 13.5 1.25Z"
        fill="#0000FF"
      />
      <path
        d="M12.2188 8.4375C10.1337 8.4375 8.4375 10.1337 8.4375 12.2188C8.4375 14.3038 10.1337 16 12.2188 16C14.3038 16 16 14.3038 16 12.2188C16 10.1337 14.3038 8.4375 12.2188 8.4375ZM12.2188 14.75C10.823 14.75 9.6875 13.6145 9.6875 12.2188C9.6875 10.823 10.823 9.6875 12.2188 9.6875C13.6145 9.6875 14.75 10.823 14.75 12.2188C14.75 13.6145 13.6145 14.75 12.2188 14.75Z"
        fill="#0000FF"
      />
      <path
        d="M13.125 11.5938H12.8438V10.9375C12.8438 10.5923 12.5639 10.3125 12.2188 10.3125C11.8736 10.3125 11.5938 10.5923 11.5938 10.9375V12.2188C11.5938 12.5639 11.8736 12.8438 12.2188 12.8438H13.125C13.4702 12.8438 13.75 12.5639 13.75 12.2188C13.75 11.8736 13.4702 11.5938 13.125 11.5938Z"
        fill="#0000FF"
      />
      <path
        d="M9.34375 7.1875C9.68893 7.1875 9.96875 6.90768 9.96875 6.5625C9.96875 6.21732 9.68893 5.9375 9.34375 5.9375C8.99857 5.9375 8.71875 6.21732 8.71875 6.5625C8.71875 6.90768 8.99857 7.1875 9.34375 7.1875Z"
        fill="#0000FF"
      />
      <path
        d="M6.625 9.90625C6.97018 9.90625 7.25 9.62643 7.25 9.28125C7.25 8.93607 6.97018 8.65625 6.625 8.65625C6.27982 8.65625 6 8.93607 6 9.28125C6 9.62643 6.27982 9.90625 6.625 9.90625Z"
        fill="#0000FF"
      />
      <path
        d="M3.90625 7.1875C4.25143 7.1875 4.53125 6.90768 4.53125 6.5625C4.53125 6.21732 4.25143 5.9375 3.90625 5.9375C3.56107 5.9375 3.28125 6.21732 3.28125 6.5625C3.28125 6.90768 3.56107 7.1875 3.90625 7.1875Z"
        fill="#0000FF"
      />
      <path
        d="M3.90625 9.90625C4.25143 9.90625 4.53125 9.62643 4.53125 9.28125C4.53125 8.93607 4.25143 8.65625 3.90625 8.65625C3.56107 8.65625 3.28125 8.93607 3.28125 9.28125C3.28125 9.62643 3.56107 9.90625 3.90625 9.90625Z"
        fill="#0000FF"
      />
      <path
        d="M3.90625 12.625C4.25143 12.625 4.53125 12.3452 4.53125 12C4.53125 11.6548 4.25143 11.375 3.90625 11.375C3.56107 11.375 3.28125 11.6548 3.28125 12C3.28125 12.3452 3.56107 12.625 3.90625 12.625Z"
        fill="#0000FF"
      />
      <path
        d="M6.625 12.625C6.97018 12.625 7.25 12.3452 7.25 12C7.25 11.6548 6.97018 11.375 6.625 11.375C6.27982 11.375 6 11.6548 6 12C6 12.3452 6.27982 12.625 6.625 12.625Z"
        fill="#0000FF"
      />
      <path
        d="M6.625 7.1875C6.97018 7.1875 7.25 6.90768 7.25 6.5625C7.25 6.21732 6.97018 5.9375 6.625 5.9375C6.27982 5.9375 6 6.21732 6 6.5625C6 6.90768 6.27982 7.1875 6.625 7.1875Z"
        fill="#0000FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_670_3793">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const alertcircle_r = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_670_3832)">
      <path
        d="M8.54996 0H7.4504C6.97915 0 6.52343 0.196594 6.20009 0.539438C5.87674 0.88225 5.70706 1.34866 5.73459 1.81909L6.2134 10.0067C6.26649 10.9142 7.02015 11.6251 7.92921 11.6251H8.07115C8.98021 11.6251 9.7339 10.9142 9.78699 10.0067L10.2658 1.81906C10.2933 1.34863 10.1236 0.882219 9.80021 0.539406C9.4769 0.196594 9.02118 0 8.54996 0ZM9.32987 1.76434L8.85109 9.95191C8.82696 10.3644 8.48437 10.6876 8.07115 10.6876H7.92921C7.51599 10.6876 7.17343 10.3644 7.14931 9.95191L6.67049 1.76434C6.65781 1.54738 6.73296 1.34078 6.88206 1.18269C7.03118 1.02456 7.23302 0.9375 7.4504 0.9375H8.54996C8.76731 0.9375 8.96912 1.02456 9.11827 1.18269C9.2674 1.34078 9.34256 1.54738 9.32987 1.76434Z"
        fill="#E44C4B"
      />
      <path
        d="M8.00018 12.5625C7.05246 12.5625 6.28143 13.3335 6.28143 14.2812C6.28143 15.2289 7.05246 16 8.00018 16C8.9479 16 9.71893 15.2289 9.71893 14.2812C9.71893 13.3335 8.9479 12.5625 8.00018 12.5625ZM8.00018 15.0625C7.5694 15.0625 7.21893 14.712 7.21893 14.2812C7.21893 13.8505 7.5694 13.5 8.00018 13.5C8.43097 13.5 8.78143 13.8505 8.78143 14.2812C8.78143 14.712 8.43097 15.0625 8.00018 15.0625Z"
        fill="#E44C4B"
      />
      <path
        d="M4.96737 7.88353C4.74369 7.753 4.45672 7.82869 4.32631 8.05228C3.94928 8.69875 3.75 9.43703 3.75 10.1873C3.75 10.9375 3.94928 11.6758 4.32631 12.3223C4.41344 12.4716 4.57038 12.5549 4.73169 12.5549C4.81184 12.5549 4.89312 12.5343 4.96737 12.491C5.191 12.3606 5.26656 12.0736 5.13616 11.8499C4.84262 11.3467 4.6875 10.7717 4.6875 10.1873C4.6875 9.60281 4.84262 9.02785 5.13616 8.52456C5.26656 8.30094 5.191 8.01391 4.96737 7.88353Z"
        fill="#E44C4B"
      />
      <path
        d="M3.34647 6.94183C3.12281 6.81139 2.83581 6.88702 2.70541 7.11061C2.16216 8.04221 1.875 9.10608 1.875 10.1872C1.875 11.2683 2.16216 12.3322 2.70544 13.2638C2.79256 13.4131 2.9495 13.4965 3.11081 13.4965C3.19097 13.4965 3.27225 13.4759 3.3465 13.4326C3.57016 13.3021 3.64572 13.0151 3.51528 12.7915C3.0555 12.0031 2.8125 11.1026 2.8125 10.1872C2.8125 9.27186 3.0555 8.3713 3.51528 7.58289C3.64569 7.35927 3.57012 7.07224 3.34647 6.94183Z"
        fill="#E44C4B"
      />
      <path
        d="M0.9375 10.1868C0.9375 8.93876 1.26762 7.71207 1.89219 6.63926C2.02244 6.41554 1.94666 6.12857 1.72291 5.99832C1.49916 5.86801 1.21222 5.94386 1.08197 6.16757C0.374156 7.38342 0 8.77329 0 10.1868C0 11.6004 0.374156 12.9902 1.08197 14.206C1.16903 14.3556 1.32609 14.439 1.48753 14.439C1.56759 14.439 1.64875 14.4185 1.72294 14.3753C1.94666 14.245 2.02244 13.9581 1.89222 13.7344C1.26762 12.6616 0.9375 11.4349 0.9375 10.1868Z"
        fill="#E44C4B"
      />
      <path
        d="M11.0375 7.88958C10.8135 8.01952 10.7374 8.3064 10.8673 8.5303C11.1585 9.03208 11.3125 9.60499 11.3125 10.1871C11.3125 10.7692 11.1585 11.3421 10.8673 11.8439C10.7374 12.0678 10.8135 12.3547 11.0375 12.4846C11.1115 12.5276 11.1924 12.5481 11.2723 12.5481C11.434 12.5481 11.5912 12.4643 11.6782 12.3145C12.0523 11.6699 12.25 10.9343 12.25 10.1871C12.25 9.43993 12.0523 8.70427 11.6782 8.05971C11.5482 7.83577 11.2613 7.75965 11.0375 7.88958Z"
        fill="#E44C4B"
      />
      <path
        d="M13.2989 7.11805C13.1688 6.89417 12.8818 6.81823 12.6581 6.94836C12.4343 7.07845 12.3583 7.36539 12.4884 7.58917C12.9458 8.37595 13.1875 9.27436 13.1875 10.1873C13.1875 11.1002 12.9458 11.9986 12.4884 12.7854C12.3583 13.0092 12.4343 13.2961 12.6581 13.4262C12.7322 13.4693 12.8133 13.4898 12.8932 13.4898C13.0547 13.4898 13.2119 13.4062 13.2989 13.2565C13.8394 12.3268 14.125 11.2655 14.125 10.1873C14.125 9.10905 13.8393 8.0477 13.2989 7.11805Z"
        fill="#E44C4B"
      />
      <path
        d="M14.9223 6.17583C14.7922 5.9519 14.5053 5.87584 14.2815 6.0059C14.0577 6.1359 13.9816 6.4228 14.1116 6.64665C14.7337 7.7178 15.0625 8.94237 15.0625 10.1879C15.0625 11.4334 14.7337 12.658 14.1116 13.7291C13.9816 13.953 14.0576 14.2399 14.2815 14.3699C14.3556 14.4129 14.4366 14.4334 14.5165 14.4334C14.6781 14.4334 14.8353 14.3497 14.9223 14.1999C15.6273 12.986 16 11.5986 16 10.1879C16 8.77718 15.6273 7.3898 14.9223 6.17583Z"
        fill="#E44C4B"
      />
    </g>
    <defs>
      <clipPath id="clip0_670_3832">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const alertcircle_g = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_670_3841)">
      <path
        d="M8.54996 0H7.4504C6.97915 0 6.52343 0.196594 6.20009 0.539438C5.87674 0.88225 5.70706 1.34866 5.73459 1.81909L6.2134 10.0067C6.26649 10.9142 7.02015 11.6251 7.92921 11.6251H8.07115C8.98021 11.6251 9.7339 10.9142 9.78699 10.0067L10.2658 1.81906C10.2933 1.34863 10.1236 0.882219 9.80021 0.539406C9.4769 0.196594 9.02118 0 8.54996 0ZM9.32987 1.76434L8.85109 9.95191C8.82696 10.3644 8.48437 10.6876 8.07115 10.6876H7.92921C7.51599 10.6876 7.17343 10.3644 7.14931 9.95191L6.67049 1.76434C6.65781 1.54738 6.73296 1.34078 6.88206 1.18269C7.03118 1.02456 7.23302 0.9375 7.4504 0.9375H8.54996C8.76731 0.9375 8.96912 1.02456 9.11827 1.18269C9.2674 1.34078 9.34256 1.54738 9.32987 1.76434Z"
        fill="#22AB94"
      />
      <path
        d="M8.00018 12.5625C7.05246 12.5625 6.28143 13.3335 6.28143 14.2812C6.28143 15.2289 7.05246 16 8.00018 16C8.9479 16 9.71893 15.2289 9.71893 14.2812C9.71893 13.3335 8.9479 12.5625 8.00018 12.5625ZM8.00018 15.0625C7.5694 15.0625 7.21893 14.712 7.21893 14.2812C7.21893 13.8505 7.5694 13.5 8.00018 13.5C8.43097 13.5 8.78143 13.8505 8.78143 14.2812C8.78143 14.712 8.43097 15.0625 8.00018 15.0625Z"
        fill="#22AB94"
      />
      <path
        d="M4.96737 7.88353C4.74369 7.753 4.45672 7.82869 4.32631 8.05228C3.94928 8.69875 3.75 9.43703 3.75 10.1873C3.75 10.9375 3.94928 11.6758 4.32631 12.3223C4.41344 12.4716 4.57038 12.5549 4.73169 12.5549C4.81184 12.5549 4.89312 12.5343 4.96737 12.491C5.191 12.3606 5.26656 12.0736 5.13616 11.8499C4.84262 11.3467 4.6875 10.7717 4.6875 10.1873C4.6875 9.60281 4.84262 9.02785 5.13616 8.52456C5.26656 8.30094 5.191 8.01391 4.96737 7.88353Z"
        fill="#22AB94"
      />
      <path
        d="M3.34647 6.94183C3.12281 6.81139 2.83581 6.88702 2.70541 7.11061C2.16216 8.04221 1.875 9.10608 1.875 10.1872C1.875 11.2683 2.16216 12.3322 2.70544 13.2638C2.79256 13.4131 2.9495 13.4965 3.11081 13.4965C3.19097 13.4965 3.27225 13.4759 3.3465 13.4326C3.57016 13.3021 3.64572 13.0151 3.51528 12.7915C3.0555 12.0031 2.8125 11.1026 2.8125 10.1872C2.8125 9.27186 3.0555 8.3713 3.51528 7.58289C3.64569 7.35927 3.57012 7.07224 3.34647 6.94183Z"
        fill="#22AB94"
      />
      <path
        d="M0.9375 10.1868C0.9375 8.93876 1.26762 7.71207 1.89219 6.63926C2.02244 6.41554 1.94666 6.12857 1.72291 5.99832C1.49916 5.86801 1.21222 5.94386 1.08197 6.16757C0.374156 7.38342 0 8.77329 0 10.1868C0 11.6004 0.374156 12.9902 1.08197 14.206C1.16903 14.3556 1.32609 14.439 1.48753 14.439C1.56759 14.439 1.64875 14.4185 1.72294 14.3753C1.94666 14.245 2.02244 13.9581 1.89222 13.7344C1.26762 12.6616 0.9375 11.4349 0.9375 10.1868Z"
        fill="#22AB94"
      />
      <path
        d="M11.0375 7.88958C10.8135 8.01952 10.7374 8.3064 10.8673 8.5303C11.1585 9.03208 11.3125 9.60499 11.3125 10.1871C11.3125 10.7692 11.1585 11.3421 10.8673 11.8439C10.7374 12.0678 10.8135 12.3547 11.0375 12.4846C11.1115 12.5276 11.1924 12.5481 11.2723 12.5481C11.434 12.5481 11.5912 12.4643 11.6782 12.3145C12.0523 11.6699 12.25 10.9343 12.25 10.1871C12.25 9.43993 12.0523 8.70427 11.6782 8.05971C11.5482 7.83577 11.2613 7.75965 11.0375 7.88958Z"
        fill="#22AB94"
      />
      <path
        d="M13.2989 7.11805C13.1688 6.89417 12.8818 6.81823 12.6581 6.94836C12.4343 7.07845 12.3583 7.36539 12.4884 7.58917C12.9458 8.37595 13.1875 9.27436 13.1875 10.1873C13.1875 11.1002 12.9458 11.9986 12.4884 12.7854C12.3583 13.0092 12.4343 13.2961 12.6581 13.4262C12.7322 13.4693 12.8133 13.4898 12.8932 13.4898C13.0547 13.4898 13.2119 13.4062 13.2989 13.2565C13.8394 12.3268 14.125 11.2655 14.125 10.1873C14.125 9.10905 13.8393 8.0477 13.2989 7.11805Z"
        fill="#22AB94"
      />
      <path
        d="M14.9223 6.17583C14.7922 5.9519 14.5053 5.87584 14.2815 6.0059C14.0577 6.1359 13.9816 6.4228 14.1116 6.64665C14.7337 7.7178 15.0625 8.94237 15.0625 10.1879C15.0625 11.4334 14.7337 12.658 14.1116 13.7291C13.9816 13.953 14.0576 14.2399 14.2815 14.3699C14.3556 14.4129 14.4366 14.4334 14.5165 14.4334C14.6781 14.4334 14.8353 14.3497 14.9223 14.1999C15.6273 12.986 16 11.5986 16 10.1879C16 8.77718 15.6273 7.3898 14.9223 6.17583Z"
        fill="#22AB94"
      />
    </g>
    <defs>
      <clipPath id="clip0_670_3841">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const alertcircle_b = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_670_3850)">
      <path
        d="M8.54996 0H7.4504C6.97915 0 6.52343 0.196594 6.20009 0.539438C5.87674 0.88225 5.70706 1.34866 5.73459 1.81909L6.2134 10.0067C6.26649 10.9142 7.02015 11.6251 7.92921 11.6251H8.07115C8.98021 11.6251 9.7339 10.9142 9.78699 10.0067L10.2658 1.81906C10.2933 1.34863 10.1236 0.882219 9.80021 0.539406C9.4769 0.196594 9.02118 0 8.54996 0ZM9.32987 1.76434L8.85109 9.95191C8.82696 10.3644 8.48437 10.6876 8.07115 10.6876H7.92921C7.51599 10.6876 7.17343 10.3644 7.14931 9.95191L6.67049 1.76434C6.65781 1.54738 6.73296 1.34078 6.88206 1.18269C7.03118 1.02456 7.23302 0.9375 7.4504 0.9375H8.54996C8.76731 0.9375 8.96912 1.02456 9.11827 1.18269C9.2674 1.34078 9.34256 1.54738 9.32987 1.76434Z"
        fill="#0000FF"
      />
      <path
        d="M8.00018 12.5625C7.05246 12.5625 6.28143 13.3335 6.28143 14.2812C6.28143 15.2289 7.05246 16 8.00018 16C8.9479 16 9.71893 15.2289 9.71893 14.2812C9.71893 13.3335 8.9479 12.5625 8.00018 12.5625ZM8.00018 15.0625C7.5694 15.0625 7.21893 14.712 7.21893 14.2812C7.21893 13.8505 7.5694 13.5 8.00018 13.5C8.43097 13.5 8.78143 13.8505 8.78143 14.2812C8.78143 14.712 8.43097 15.0625 8.00018 15.0625Z"
        fill="#0000FF"
      />
      <path
        d="M4.96737 7.88353C4.74369 7.753 4.45672 7.82869 4.32631 8.05228C3.94928 8.69875 3.75 9.43703 3.75 10.1873C3.75 10.9375 3.94928 11.6758 4.32631 12.3223C4.41344 12.4716 4.57038 12.5549 4.73169 12.5549C4.81184 12.5549 4.89312 12.5343 4.96737 12.491C5.191 12.3606 5.26656 12.0736 5.13616 11.8499C4.84262 11.3467 4.6875 10.7717 4.6875 10.1873C4.6875 9.60281 4.84262 9.02785 5.13616 8.52456C5.26656 8.30094 5.191 8.01391 4.96737 7.88353Z"
        fill="#0000FF"
      />
      <path
        d="M3.34647 6.94183C3.12281 6.81139 2.83581 6.88702 2.70541 7.11061C2.16216 8.04221 1.875 9.10608 1.875 10.1872C1.875 11.2683 2.16216 12.3322 2.70544 13.2638C2.79256 13.4131 2.9495 13.4965 3.11081 13.4965C3.19097 13.4965 3.27225 13.4759 3.3465 13.4326C3.57016 13.3021 3.64572 13.0151 3.51528 12.7915C3.0555 12.0031 2.8125 11.1026 2.8125 10.1872C2.8125 9.27186 3.0555 8.3713 3.51528 7.58289C3.64569 7.35927 3.57012 7.07224 3.34647 6.94183Z"
        fill="#0000FF"
      />
      <path
        d="M0.9375 10.1868C0.9375 8.93876 1.26762 7.71207 1.89219 6.63926C2.02244 6.41554 1.94666 6.12857 1.72291 5.99832C1.49916 5.86801 1.21222 5.94386 1.08197 6.16757C0.374156 7.38342 0 8.77329 0 10.1868C0 11.6004 0.374156 12.9902 1.08197 14.206C1.16903 14.3556 1.32609 14.439 1.48753 14.439C1.56759 14.439 1.64875 14.4185 1.72294 14.3753C1.94666 14.245 2.02244 13.9581 1.89222 13.7344C1.26762 12.6616 0.9375 11.4349 0.9375 10.1868Z"
        fill="#0000FF"
      />
      <path
        d="M11.0375 7.88958C10.8135 8.01952 10.7374 8.3064 10.8673 8.5303C11.1585 9.03208 11.3125 9.60499 11.3125 10.1871C11.3125 10.7692 11.1585 11.3421 10.8673 11.8439C10.7374 12.0678 10.8135 12.3547 11.0375 12.4846C11.1115 12.5276 11.1924 12.5481 11.2723 12.5481C11.434 12.5481 11.5912 12.4643 11.6782 12.3145C12.0523 11.6699 12.25 10.9343 12.25 10.1871C12.25 9.43993 12.0523 8.70427 11.6782 8.05971C11.5482 7.83577 11.2613 7.75965 11.0375 7.88958Z"
        fill="#0000FF"
      />
      <path
        d="M13.2989 7.11805C13.1688 6.89417 12.8818 6.81823 12.6581 6.94836C12.4343 7.07845 12.3583 7.36539 12.4884 7.58917C12.9458 8.37595 13.1875 9.27436 13.1875 10.1873C13.1875 11.1002 12.9458 11.9986 12.4884 12.7854C12.3583 13.0092 12.4343 13.2961 12.6581 13.4262C12.7322 13.4693 12.8133 13.4898 12.8932 13.4898C13.0547 13.4898 13.2119 13.4062 13.2989 13.2565C13.8394 12.3268 14.125 11.2655 14.125 10.1873C14.125 9.10905 13.8393 8.0477 13.2989 7.11805Z"
        fill="#0000FF"
      />
      <path
        d="M14.9223 6.17583C14.7922 5.9519 14.5053 5.87584 14.2815 6.0059C14.0577 6.1359 13.9816 6.4228 14.1116 6.64665C14.7337 7.7178 15.0625 8.94237 15.0625 10.1879C15.0625 11.4334 14.7337 12.658 14.1116 13.7291C13.9816 13.953 14.0576 14.2399 14.2815 14.3699C14.3556 14.4129 14.4366 14.4334 14.5165 14.4334C14.6781 14.4334 14.8353 14.3497 14.9223 14.1999C15.6273 12.986 16 11.5986 16 10.1879C16 8.77718 15.6273 7.3898 14.9223 6.17583Z"
        fill="#0000FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_670_3850">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const chevrondown = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_670_3859)">
      <path
        d="M7.99793 8.75013C7.49712 8.75013 7.02629 8.55507 6.67211 8.20089L1.67219 3.20098C1.31807 2.84683 1.12305 2.37599 1.12305 1.87519C1.12305 0.841332 1.96416 0.0002213 2.99801 0.0002213C3.49885 0.0002213 3.96968 0.195249 4.32383 0.54943L7.99858 4.22418L11.6727 0.56068C12.1595 0.0742512 12.8014 -0.107496 13.434 0.0620327C14.1032 0.241342 14.6508 0.787176 14.8291 1.45263C14.9977 2.08153 14.8134 2.72311 14.3236 3.21292L9.32318 8.20142C8.96956 8.55507 8.49873 8.75013 7.99793 8.75013ZM2.99801 1.2502C2.6534 1.2502 2.37303 1.53057 2.37303 1.87519C2.37303 2.04212 2.43805 2.19906 2.55608 2.31712L7.556 7.31703C7.67409 7.43512 7.83102 7.50015 7.99793 7.50015C8.16483 7.50015 8.32176 7.43512 8.43986 7.31703L13.4403 2.32849C13.615 2.15381 13.6745 1.97297 13.6218 1.77613C13.5589 1.5416 13.3487 1.33323 13.1105 1.26942C12.9095 1.21554 12.7281 1.27304 12.5559 1.4452C12.5557 1.44541 12.5555 1.44563 12.5553 1.44585L8.4392 5.54997C8.19505 5.79343 7.7998 5.79315 7.55596 5.54931L3.43994 1.43329C3.32188 1.3152 3.16495 1.2502 2.99801 1.2502Z"
        fill="#E44C4B"
      />
      <path
        d="M7.99798 16.0004C7.49718 16.0004 7.02634 15.8054 6.67216 15.4512L1.67225 10.4513C0.892574 9.67158 0.948573 8.54435 1.68559 7.8073C2.41608 7.07684 3.53743 7.01331 4.32383 7.79974L7.99795 11.4739L11.6721 7.79974C12.1589 7.31287 12.8012 7.13084 13.434 7.30043C14.1032 7.47974 14.6509 8.02558 14.8292 8.691C14.9977 9.3199 14.8135 9.96151 14.3237 10.4513L9.32374 15.4512C8.96962 15.8054 8.49878 16.0004 7.99798 16.0004ZM2.56945 8.69116C2.4952 8.76544 2.14549 9.15674 2.55611 9.56742L7.55602 14.5673C7.67411 14.6854 7.83105 14.7505 7.99795 14.7505C8.16485 14.7505 8.32179 14.6854 8.43988 14.5673L13.4398 9.56742C13.615 9.39221 13.6745 9.21134 13.6218 9.01453C13.5589 8.78 13.3487 8.57163 13.1105 8.50779C12.9096 8.45394 12.7281 8.51141 12.5559 8.68356L8.43991 12.7996C8.19582 13.0437 7.80011 13.0437 7.55605 12.7996L3.44 8.68359C3.15747 8.4011 2.83179 8.42888 2.56945 8.69116Z"
        fill="#E44C4B"
      />
    </g>
    <defs>
      <clipPath id="clip0_670_3859">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const bottomright = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
  >
    <g clipPath="url(#clip0_670_3865)">
      <path
        d="M17.1562 16.3713L16.4352 10.0284C16.353 9.38036 15.5499 9.08831 15.0844 9.55377L14.1444 10.4938C13.8432 10.795 13.3778 10.8589 13.0766 10.5577L7.46372 4.94483C7.16254 4.64365 6.69708 4.61627 6.38678 4.92658L4.90827 6.40509C4.61621 6.69714 4.60709 7.1991 4.90827 7.50028L10.5211 13.1131C10.8223 13.4143 10.7857 13.8525 10.4846 14.1536L9.54458 15.0936C9.08825 15.55 9.3803 16.3531 10.0192 16.4261L16.28 17.211C16.782 17.2931 17.2201 16.8733 17.1562 16.3713Z"
        fill="#E44C4B"
      />
    </g>
    <defs>
      <clipPath id="clip0_670_3865">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(11.3137) rotate(45)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const down = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <g clipPath="url(#clip0_670_3902)">
      <path
        d="M8.86839 16.0213L12.8437 11.0263C13.2439 10.51 12.8825 9.73557 12.2242 9.73557H10.8948C10.4689 9.73557 10.0946 9.45161 10.0946 9.02568V1.0879C10.0946 0.661965 9.78478 0.313477 9.34595 0.313477L7.25502 0.313477C6.84199 0.313477 6.4806 0.661965 6.4806 1.0879L6.4806 9.02568C6.4806 9.45161 6.14489 9.73557 5.71909 9.73557H4.38967C3.74432 9.73557 3.38292 10.51 3.78304 11.0134L7.65513 15.9955C7.95199 16.4085 8.55862 16.4214 8.86839 16.0213Z"
        fill="#E44C4B"
      />
    </g>
    <defs>
      <clipPath id="clip0_670_3902">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="matrix(0 1 -1 0 16.3137 0.313477)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const chevronup = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_670_3905)">
      <path
        d="M7.99793 7.24987C7.49712 7.24987 7.02629 7.44493 6.67211 7.79911L1.67219 12.799C1.31807 13.1532 1.12305 13.624 1.12305 14.1248C1.12305 15.1587 1.96416 15.9998 2.99801 15.9998C3.49885 15.9998 3.96968 15.8048 4.32383 15.4506L7.99858 11.7758L11.6727 15.4393C12.1595 15.9257 12.8014 16.1075 13.434 15.938C14.1032 15.7587 14.6508 15.2128 14.8291 14.5474C14.9977 13.9185 14.8134 13.2769 14.3236 12.7871L9.32318 7.79858C8.96956 7.44493 8.49873 7.24987 7.99793 7.24987ZM2.99801 14.7498C2.6534 14.7498 2.37303 14.4694 2.37303 14.1248C2.37303 13.9579 2.43805 13.8009 2.55608 13.6829L7.556 8.68297C7.67409 8.56488 7.83102 8.49985 7.99793 8.49985C8.16483 8.49985 8.32176 8.56488 8.43986 8.68297L13.4403 13.6715C13.615 13.8462 13.6745 14.027 13.6218 14.2239C13.5589 14.4584 13.3487 14.6668 13.1105 14.7306C12.9095 14.7845 12.7281 14.727 12.5559 14.5548C12.5557 14.5546 12.5555 14.5544 12.5553 14.5541L8.4392 10.45C8.19505 10.2066 7.7998 10.2068 7.55596 10.4507L3.43994 14.5667C3.32188 14.6848 3.16495 14.7498 2.99801 14.7498Z"
        fill="#22AB94"
      />
      <path
        d="M7.99798 -0.000433922C7.49718 -0.000433922 7.02634 0.194624 6.67216 0.548805L1.67225 5.54872C0.892574 6.32842 0.948573 7.45565 1.68559 8.1927C2.41608 8.92316 3.53743 8.98669 4.32383 8.20026L7.99795 4.52614L11.6721 8.20026C12.1589 8.68713 12.8012 8.86916 13.434 8.69957C14.1032 8.52026 14.6509 7.97442 14.8292 7.309C14.9977 6.6801 14.8135 6.03849 14.3237 5.54872L9.32374 0.548805C8.96962 0.194624 8.49878 -0.000433922 7.99798 -0.000433922ZM2.56945 7.30884C2.4952 7.23456 2.14549 6.84326 2.55611 6.43258L7.55602 1.43267C7.67411 1.31457 7.83105 1.24954 7.99795 1.24954C8.16485 1.24954 8.32179 1.31457 8.43988 1.43267L13.4398 6.43258C13.615 6.60779 13.6745 6.78866 13.6218 6.98547C13.5589 7.22 13.3487 7.42837 13.1105 7.49221C12.9096 7.54606 12.7281 7.48859 12.5559 7.31644L8.43991 3.20038C8.19582 2.95629 7.80011 2.95629 7.55605 3.20038L3.44 7.31641C3.15747 7.5989 2.83179 7.57112 2.56945 7.30884Z"
        fill="#22AB94"
      />
    </g>
    <defs>
      <clipPath id="clip0_670_3905">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="matrix(1 0 0 -1 0 16)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const newhigh = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_670_3911)">
      <path
        d="M15.8913 0.476514C15.8547 0.289181 15.7083 0.142746 15.5209 0.106223C13.2097 -0.344457 10.2946 0.661035 7.8079 2.70301C7.16151 2.38924 6.41856 2.27264 5.70287 2.3754C4.92411 2.48722 4.21883 2.83998 3.66327 3.39555L0.635885 6.42293C0.507632 6.55118 0.464861 6.74198 0.526191 6.91269C0.587521 7.08344 0.74183 7.20344 0.922446 7.22078L4.00038 7.51656C3.94392 7.63697 3.88956 7.75763 3.83788 7.87857C3.58707 8.46556 3.7116 9.11054 4.16294 9.56185L6.43558 11.8345C6.73273 12.1316 7.11381 12.2871 7.507 12.2871C7.71101 12.2871 7.91834 12.2453 8.11886 12.1596C8.24152 12.1072 8.36387 12.052 8.48597 11.9947L8.78252 15.0809C8.7999 15.2614 8.9199 15.4158 9.09061 15.4771C9.14232 15.4956 9.19587 15.5047 9.24895 15.5047C9.37114 15.5047 9.49096 15.4568 9.58038 15.3674L12.6078 12.34C13.7075 11.2403 13.9738 9.56766 13.2967 8.18778C15.3463 5.69306 16.3376 2.76566 15.8913 0.476514ZM9.36936 10.4404L5.55709 6.6281C6.06901 5.82091 6.69177 5.04524 7.40358 4.33343C8.61259 3.12442 9.97697 2.19628 11.3311 1.61779L14.3771 4.66379C13.9158 5.74577 13.2316 6.83687 12.3562 7.8498C12.1369 8.10349 11.904 8.35381 11.664 8.59385C10.9522 9.30569 10.1766 9.92848 9.36936 10.4404ZM14.3608 0.934911C14.586 0.934911 14.807 0.948221 15.0221 0.975184C15.1262 1.81131 15.0218 2.73807 14.7319 3.69304L12.3016 1.26278C13.0102 1.04767 13.7047 0.934911 14.3608 0.934911ZM2.00142 6.38291L4.32599 4.0583C5.03143 3.35287 6.08519 3.10939 7.02148 3.39758C6.9271 3.48712 6.83346 3.57807 6.74083 3.6707C5.8374 4.57413 5.06642 5.57643 4.46746 6.61988L2.00142 6.38291ZM7.75054 11.2978C7.51971 11.3964 7.27589 11.3493 7.09834 11.1718L4.82569 8.89915C4.64817 8.72163 4.60112 8.47784 4.69975 8.24696C4.81138 7.98577 4.93536 7.72557 5.07092 7.46741L8.53008 10.9266C8.27192 11.0622 8.01173 11.1861 7.75054 11.2978ZM11.9451 11.6773L9.62043 14.0019L9.38264 11.5271C10.4243 10.9286 11.4249 10.1586 12.3268 9.25664C12.4205 9.16297 12.5127 9.06743 12.604 8.97114C12.9016 9.91021 12.6635 10.9588 11.9451 11.6773Z"
        fill="#22AB94"
      />
      <path
        d="M11.4165 4.581C10.8198 3.98438 9.84907 3.98441 9.25249 4.581C8.65587 5.17761 8.65587 6.14836 9.25249 6.74498C9.54148 7.03398 9.92574 7.19316 10.3345 7.19316C10.7432 7.19316 11.1275 7.03398 11.4165 6.74498C12.0131 6.14836 12.0131 5.17761 11.4165 4.581ZM10.7537 6.08222C10.6417 6.1942 10.4928 6.25587 10.3345 6.25587C10.1761 6.25587 10.0272 6.1942 9.91524 6.08222C9.68411 5.85105 9.68411 5.47492 9.91524 5.24375C10.0308 5.12818 10.1827 5.07038 10.3345 5.07038C10.4863 5.07038 10.6381 5.12818 10.7537 5.24375C10.9848 5.47492 10.9848 5.85105 10.7537 6.08222Z"
        fill="#22AB94"
      />
      <path
        d="M4.58147 11.4214C4.39848 11.2384 4.10173 11.2384 3.91871 11.4214L0.140623 15.1995C-0.0423984 15.3826 -0.0423984 15.6793 0.140623 15.8623C0.232134 15.9538 0.352075 15.9996 0.471986 15.9996C0.591897 15.9996 0.71187 15.9538 0.803349 15.8623L4.58144 12.0842C4.76449 11.9012 4.76449 11.6045 4.58147 11.4214Z"
        fill="#22AB94"
      />
      <path
        d="M1.80417 11.8592L3.08023 10.5832C3.26325 10.4002 3.26325 10.1035 3.08023 9.92046C2.89727 9.73744 2.60053 9.73747 2.41747 9.92046L1.14142 11.1965C0.958395 11.3795 0.958395 11.6762 1.14142 11.8592C1.23293 11.9508 1.35287 11.9965 1.47278 11.9965C1.59272 11.9965 1.71269 11.9507 1.80417 11.8592Z"
        fill="#22AB94"
      />
      <path
        d="M5.41995 12.9234L4.14392 14.1994C3.9609 14.3824 3.9609 14.6792 4.14392 14.8622C4.23543 14.9537 4.35537 14.9995 4.47528 14.9995C4.59519 14.9995 4.71517 14.9537 4.80665 14.8622L6.08267 13.5862C6.26569 13.4031 6.26569 13.1064 6.08267 12.9234C5.89968 12.7404 5.60294 12.7404 5.41995 12.9234Z"
        fill="#22AB94"
      />
    </g>
    <defs>
      <clipPath id="clip0_670_3911">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const newlow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_670_3951)">
      <path
        d="M15.8913 15.5235C15.8547 15.7108 15.7083 15.8573 15.5209 15.8938C13.2097 16.3445 10.2946 15.339 7.8079 13.297C7.16151 13.6108 6.41856 13.7274 5.70287 13.6246C4.92411 13.5128 4.21883 13.16 3.66327 12.6045L0.635885 9.57707C0.507632 9.44882 0.464861 9.25802 0.526191 9.08731C0.587521 8.91656 0.74183 8.79656 0.922446 8.77922L4.00038 8.48344C3.94392 8.36303 3.88956 8.24237 3.83788 8.12143C3.58707 7.53444 3.7116 6.88946 4.16294 6.43815L6.43558 4.16551C6.73273 3.86835 7.11381 3.71286 7.507 3.71286C7.71101 3.71286 7.91834 3.75472 8.11886 3.84042C8.24152 3.89282 8.36387 3.94796 8.48597 4.00529L8.78252 0.91914C8.7999 0.738587 8.9199 0.584248 9.09061 0.522918C9.14232 0.504359 9.19587 0.49533 9.24895 0.49533C9.37114 0.49533 9.49096 0.543194 9.58038 0.632611L12.6078 3.65999C13.7075 4.75975 13.9738 6.43234 13.2967 7.81222C15.3463 10.3069 16.3376 13.2343 15.8913 15.5235ZM9.36936 5.55963L5.55709 9.3719C6.06901 10.1791 6.69177 10.9548 7.40358 11.6666C8.61259 12.8756 9.97697 13.8037 11.3311 14.3822L14.3771 11.3362C13.9158 10.2542 13.2316 9.16313 12.3562 8.1502C12.1369 7.89651 11.904 7.64619 11.664 7.40615C10.9522 6.69431 10.1766 6.07152 9.36936 5.55963ZM14.3608 15.0651C14.586 15.0651 14.807 15.0518 15.0221 15.0248C15.1262 14.1887 15.0218 13.2619 14.7319 12.307L12.3016 14.7372C13.0102 14.9523 13.7047 15.0651 14.3608 15.0651ZM2.00142 9.61709L4.32599 11.9417C5.03143 12.6471 6.08519 12.8906 7.02148 12.6024C6.9271 12.5129 6.83346 12.4219 6.74083 12.3293C5.8374 11.4259 5.06642 10.4236 4.46746 9.38012L2.00142 9.61709ZM7.75054 4.70223C7.51971 4.60359 7.27589 4.65068 7.09834 4.8282L4.82569 7.10085C4.64817 7.27837 4.60112 7.52216 4.69975 7.75304C4.81138 8.01423 4.93536 8.27443 5.07092 8.53259L8.53008 5.07339C8.27192 4.93783 8.01173 4.81386 7.75054 4.70223ZM11.9451 4.32269L9.62043 1.99809L9.38264 4.47287C10.4243 5.07143 11.4249 5.84138 12.3268 6.74336C12.4205 6.83703 12.5127 6.93257 12.604 7.02886C12.9016 6.08979 12.6635 5.04115 11.9451 4.32269Z"
        fill="#E44C4B"
      />
      <path
        d="M11.4165 11.419C10.8198 12.0156 9.84907 12.0156 9.25249 11.419C8.65587 10.8224 8.65587 9.85164 9.25249 9.25502C9.54148 8.96602 9.92574 8.80684 10.3345 8.80684C10.7432 8.80684 11.1275 8.96602 11.4165 9.25502C12.0131 9.85164 12.0131 10.8224 11.4165 11.419ZM10.7537 9.91778C10.6417 9.8058 10.4928 9.74413 10.3345 9.74413C10.1761 9.74413 10.0272 9.8058 9.91524 9.91778C9.68411 10.1489 9.68411 10.5251 9.91524 10.7562C10.0308 10.8718 10.1827 10.9296 10.3345 10.9296C10.4863 10.9296 10.6381 10.8718 10.7537 10.7562C10.9848 10.5251 10.9848 10.1489 10.7537 9.91778Z"
        fill="#E44C4B"
      />
      <path
        d="M4.58147 4.57855C4.39848 4.76158 4.10173 4.76158 3.91871 4.57855L0.140623 0.800465C-0.0423984 0.617444 -0.0423984 0.320729 0.140623 0.137708C0.232134 0.0461969 0.352075 0.000426769 0.471986 0.000426769C0.591897 0.000426769 0.71187 0.0461659 0.803349 0.137708L4.58144 3.9158C4.76449 4.09882 4.76449 4.39553 4.58147 4.57855Z"
        fill="#E44C4B"
      />
      <path
        d="M1.80417 4.14076L3.08023 5.41679C3.26325 5.59981 3.26325 5.89652 3.08023 6.07954C2.89727 6.26256 2.60053 6.26253 2.41747 6.07954L1.14142 4.80352C0.958395 4.6205 0.958395 4.32378 1.14142 4.14076C1.23293 4.04925 1.35287 4.00348 1.47278 4.00348C1.59272 4.00351 1.71269 4.04928 1.80417 4.14076Z"
        fill="#E44C4B"
      />
      <path
        d="M5.41995 3.0766L4.14392 1.80057C3.9609 1.61755 3.9609 1.32084 4.14392 1.13782C4.23543 1.04631 4.35537 1.00054 4.47528 1.00054C4.59519 1.00054 4.71517 1.04628 4.80665 1.13782L6.08267 2.41384C6.26569 2.59686 6.26569 2.89358 6.08267 3.0766C5.89968 3.25962 5.60294 3.25962 5.41995 3.0766Z"
        fill="#E44C4B"
      />
    </g>
    <defs>
      <clipPath id="clip0_670_3951">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="matrix(1 0 0 -1 0 16)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const sad = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_670_3957)">
      <path
        d="M8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0ZM8 14.5455C4.39084 14.5455 1.45455 11.6092 1.45455 8C1.45455 4.39079 4.39084 1.45455 8 1.45455C11.6092 1.45455 14.5455 4.39084 14.5455 8C14.5455 11.6092 11.6092 14.5455 8 14.5455Z"
        fill="#E44C4B"
      />
      <path
        d="M7.99994 8.71875C7.99989 8.71875 7.99999 8.71875 7.99994 8.71875C6.87325 8.71875 5.8139 9.15754 5.01725 9.95424C4.73322 10.2382 4.73322 10.6987 5.01725 10.9828C5.15926 11.1248 5.34539 11.1958 5.53153 11.1958C5.71766 11.1958 5.90379 11.1248 6.04576 10.9828C6.56774 10.4608 7.26176 10.1733 7.99994 10.1733C8.73812 10.1733 9.43213 10.4608 9.95412 10.9828C10.2381 11.2667 10.6986 11.2667 10.9826 10.9828C11.2667 10.6988 11.2667 10.2383 10.9826 9.95424C10.1859 9.15754 9.12668 8.71875 7.99994 8.71875Z"
        fill="#E44C4B"
      />
      <path
        d="M5.58255 7.13379C5.7634 6.95342 5.86667 6.70324 5.86667 6.44821C5.86667 6.19318 5.7634 5.943 5.58255 5.76259C5.40219 5.58227 5.152 5.47852 4.89697 5.47852C4.64146 5.47852 4.39176 5.58227 4.2114 5.76259C4.03103 5.943 3.92728 6.19318 3.92728 6.44821C3.92728 6.70324 4.03103 6.95342 4.2114 7.13379C4.39176 7.31415 4.64194 7.41791 4.89697 7.41791C5.152 7.41791 5.40219 7.31415 5.58255 7.13379Z"
        fill="#E44C4B"
      />
      <path
        d="M11.103 5.47852C10.8475 5.47852 10.5978 5.58227 10.4175 5.76259C10.2366 5.943 10.1333 6.19318 10.1333 6.44821C10.1333 6.70324 10.2366 6.95342 10.4175 7.13379C10.5978 7.31415 10.848 7.41791 11.103 7.41791C11.3581 7.41791 11.6082 7.3141 11.7886 7.13379C11.9695 6.95342 12.0727 6.70324 12.0727 6.44821C12.0727 6.19318 11.9695 5.943 11.7886 5.76259C11.6082 5.58227 11.3581 5.47852 11.103 5.47852Z"
        fill="#E44C4B"
      />
    </g>
    <defs>
      <clipPath id="clip0_670_3957">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const smile = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_670_3992)">
      <path
        d="M7.96875 12.375C5.09375 12.375 3.75586 9.96252 3.7002 9.85986C3.53601 9.55627 3.64905 9.177 3.95264 9.0127C4.25635 8.84851 4.6355 8.96155 4.79968 9.26514C4.80103 9.26758 5.07043 9.74939 5.60632 10.2179C6.2948 10.8198 7.0896 11.125 7.96875 11.125C10.1071 11.125 11.1277 9.28369 11.1377 9.26514C11.302 8.96155 11.6813 8.84851 11.9849 9.01282C12.2885 9.177 12.4015 9.55627 12.2372 9.85986C12.1816 9.96252 10.8438 12.375 7.96875 12.375ZM12.1394 14.847C12.4347 14.6682 12.5291 14.2839 12.3502 13.9886C12.1714 13.6935 11.787 13.5991 11.4918 13.778C10.442 14.4138 9.2345 14.75 8 14.75C4.27808 14.75 1.25 11.7219 1.25 8C1.25 4.27808 4.27808 1.25 8 1.25C11.7219 1.25 14.75 4.27808 14.75 8C14.75 9.33093 14.3542 10.6263 13.6055 11.7463C13.4136 12.0333 13.4907 12.4215 13.7776 12.6133C14.0647 12.8052 14.4528 12.728 14.6445 12.441C15.5314 11.1149 16 9.5791 16 8C16 5.86316 15.1678 3.85413 13.6569 2.34314C12.1459 0.832153 10.1368 0 8 0C5.86316 0 3.85413 0.832153 2.34314 2.34314C0.832153 3.85413 0 5.86316 0 8C0 10.1368 0.832153 12.1459 2.34314 13.6569C3.85413 15.1678 5.86316 16 8 16C9.46289 16 10.8943 15.6013 12.1394 14.847ZM12.3438 6.5C12.3438 5.63843 11.6428 4.9375 10.7812 4.9375C9.91968 4.9375 9.21875 5.63843 9.21875 6.5C9.21875 6.84521 9.49854 7.125 9.84375 7.125C10.189 7.125 10.4688 6.84521 10.4688 6.5C10.4688 6.32764 10.6089 6.1875 10.7812 6.1875C10.9536 6.1875 11.0938 6.32764 11.0938 6.5C11.0938 6.84521 11.3735 7.125 11.7188 7.125C12.064 7.125 12.3438 6.84521 12.3438 6.5ZM6.8125 6.5C6.8125 5.63843 6.11157 4.9375 5.25 4.9375C4.38843 4.9375 3.6875 5.63843 3.6875 6.5C3.6875 6.84521 3.96729 7.125 4.3125 7.125C4.65771 7.125 4.9375 6.84521 4.9375 6.5C4.9375 6.32764 5.07764 6.1875 5.25 6.1875C5.42236 6.1875 5.5625 6.32764 5.5625 6.5C5.5625 6.84521 5.84229 7.125 6.1875 7.125C6.53271 7.125 6.8125 6.84521 6.8125 6.5Z"
        fill="#22AB94"
      />
    </g>
    <defs>
      <clipPath id="clip0_670_3992">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const thumbsdown = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_670_3994)">
      <path
        d="M14.6722 6.09375C14.8953 6.34281 15.0312 6.67156 15.0312 7.03125C15.0312 7.80656 14.4003 8.4375 13.625 8.4375H10.8956C11.1659 9.25781 11.2812 10.3462 11.2812 10.8128V11.2812C11.2812 12.315 10.44 13.1562 9.40625 13.1562H8.9375C8.7225 13.1562 8.535 13.01 8.48281 12.8012L8.2275 11.7797C7.86969 10.3491 6.73375 8.77063 5.55813 8.48375C5.35219 9.005 4.84375 9.375 4.25 9.375H1.4375C1.17875 9.375 0.96875 9.165 0.96875 8.90625V0.46875C0.96875 0.21 1.17875 0 1.4375 0H4.25C4.80906 0 5.29281 0.327812 5.51937 0.801562L7.13 0.264688C7.65656 0.0890627 8.20531 0 8.76062 0H12.6875C13.4628 0 14.0938 0.630938 14.0938 1.40625C14.0938 1.58906 14.0588 1.76406 13.995 1.92437C14.5912 2.08719 15.0312 2.63375 15.0312 3.28125C15.0312 3.64094 14.8953 3.96969 14.6722 4.21875C14.8953 4.46781 15.0312 4.79656 15.0312 5.15625C15.0312 5.51594 14.8953 5.84469 14.6722 6.09375ZM4.71875 1.40625C4.71875 1.14781 4.50844 0.9375 4.25 0.9375H1.90625V8.4375H4.25C4.50844 8.4375 4.71875 8.22719 4.71875 7.96875V1.40625ZM12.6875 5.625H13.625C13.8834 5.625 14.0938 5.41469 14.0938 5.15625C14.0938 4.89781 13.8834 4.6875 13.625 4.6875H12.6875C12.4288 4.6875 12.2188 4.4775 12.2188 4.21875C12.2188 3.96 12.4288 3.75 12.6875 3.75H13.625C13.8834 3.75 14.0938 3.53969 14.0938 3.28125C14.0938 3.02281 13.8834 2.8125 13.625 2.8125H12.6875C12.4288 2.8125 12.2188 2.6025 12.2188 2.34375C12.2188 2.085 12.4288 1.875 12.6875 1.875C12.9459 1.875 13.1562 1.66469 13.1562 1.40625C13.1562 1.14781 12.9459 0.9375 12.6875 0.9375H8.76062C8.30625 0.9375 7.85719 1.01031 7.42625 1.15406L5.65625 1.74406V7.54438C6.39156 7.68406 7.11125 8.14969 7.76094 8.91187C8.39531 9.65625 8.90969 10.6431 9.13688 11.5522L9.30344 12.2188H9.40625C9.92313 12.2188 10.3438 11.7981 10.3438 11.2812V10.8128C10.3438 10.1834 10.1469 8.97625 9.895 8.4375H8.9375C8.67875 8.4375 8.46875 8.2275 8.46875 7.96875C8.46875 7.71 8.67875 7.5 8.9375 7.5H13.625C13.8834 7.5 14.0938 7.28969 14.0938 7.03125C14.0938 6.77281 13.8834 6.5625 13.625 6.5625H12.6875C12.4288 6.5625 12.2188 6.3525 12.2188 6.09375C12.2188 5.835 12.4288 5.625 12.6875 5.625Z"
        fill="#E44C4B"
      />
      <path
        d="M3.3125 1.875C3.57138 1.875 3.78125 2.08487 3.78125 2.34375C3.78125 2.60263 3.57138 2.8125 3.3125 2.8125C3.05362 2.8125 2.84375 2.60263 2.84375 2.34375C2.84375 2.08487 3.05362 1.875 3.3125 1.875Z"
        fill="#E44C4B"
      />
      <path
        d="M9.875 16C9.61612 16 9.40625 15.7901 9.40625 15.5312V14.5625C9.40625 14.3036 9.61612 14.0938 9.875 14.0938C10.1339 14.0938 10.3438 14.3036 10.3438 14.5625V15.5312C10.3438 15.7901 10.1339 16 9.875 16Z"
        fill="#E44C4B"
      />
      <path
        d="M7.8862 13.9322L7.2233 14.5951C7.04027 14.7782 6.74346 14.7782 6.56039 14.5951C6.37733 14.4121 6.37733 14.1153 6.56039 13.9322L7.2233 13.2693C7.40633 13.0863 7.70317 13.0862 7.8862 13.2693C8.06927 13.4524 8.06927 13.7492 7.8862 13.9322Z"
        fill="#E44C4B"
      />
      <path
        d="M13.1896 14.5951C13.0065 14.7782 12.7097 14.7782 12.5267 14.5951L11.8638 13.9322C11.6807 13.7492 11.6807 13.4524 11.8638 13.2693C12.0468 13.0863 12.3436 13.0863 12.5267 13.2693L13.1896 13.9322C13.3726 14.1153 13.3726 14.4121 13.1896 14.5951Z"
        fill="#E44C4B"
      />
    </g>
    <defs>
      <clipPath id="clip0_670_3994">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="matrix(1 0 0 -1 0 16)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const thumbsup = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_670_4025)">
      <path
        d="M14.6722 9.90625C14.8953 9.65719 15.0312 9.32844 15.0312 8.96875C15.0312 8.19344 14.4003 7.5625 13.625 7.5625H10.8956C11.1659 6.74219 11.2812 5.65375 11.2812 5.18719V4.71875C11.2812 3.685 10.44 2.84375 9.40625 2.84375H8.9375C8.7225 2.84375 8.535 2.99 8.48281 3.19875L8.2275 4.22031C7.86969 5.65094 6.73375 7.22937 5.55813 7.51625C5.35219 6.995 4.84375 6.625 4.25 6.625H1.4375C1.17875 6.625 0.96875 6.835 0.96875 7.09375V15.5312C0.96875 15.79 1.17875 16 1.4375 16H4.25C4.80906 16 5.29281 15.6722 5.51937 15.1984L7.13 15.7353C7.65656 15.9109 8.20531 16 8.76062 16H12.6875C13.4628 16 14.0938 15.3691 14.0938 14.5938C14.0938 14.4109 14.0588 14.2359 13.995 14.0756C14.5912 13.9128 15.0312 13.3663 15.0312 12.7188C15.0312 12.3591 14.8953 12.0303 14.6722 11.7812C14.8953 11.5322 15.0312 11.2034 15.0312 10.8438C15.0312 10.4841 14.8953 10.1553 14.6722 9.90625ZM4.71875 14.5938C4.71875 14.8522 4.50844 15.0625 4.25 15.0625H1.90625V7.5625H4.25C4.50844 7.5625 4.71875 7.77281 4.71875 8.03125V14.5938ZM12.6875 10.375H13.625C13.8834 10.375 14.0938 10.5853 14.0938 10.8438C14.0938 11.1022 13.8834 11.3125 13.625 11.3125H12.6875C12.4288 11.3125 12.2188 11.5225 12.2188 11.7812C12.2188 12.04 12.4288 12.25 12.6875 12.25H13.625C13.8834 12.25 14.0938 12.4603 14.0938 12.7188C14.0938 12.9772 13.8834 13.1875 13.625 13.1875H12.6875C12.4288 13.1875 12.2188 13.3975 12.2188 13.6562C12.2188 13.915 12.4288 14.125 12.6875 14.125C12.9459 14.125 13.1562 14.3353 13.1562 14.5938C13.1562 14.8522 12.9459 15.0625 12.6875 15.0625H8.76062C8.30625 15.0625 7.85719 14.9897 7.42625 14.8459L5.65625 14.2559V8.45562C6.39156 8.31594 7.11125 7.85031 7.76094 7.08813C8.39531 6.34375 8.90969 5.35687 9.13688 4.44781L9.30344 3.78125H9.40625C9.92313 3.78125 10.3438 4.20187 10.3438 4.71875V5.18719C10.3438 5.81656 10.1469 7.02375 9.895 7.5625H8.9375C8.67875 7.5625 8.46875 7.7725 8.46875 8.03125C8.46875 8.29 8.67875 8.5 8.9375 8.5H13.625C13.8834 8.5 14.0938 8.71031 14.0938 8.96875C14.0938 9.22719 13.8834 9.4375 13.625 9.4375H12.6875C12.4288 9.4375 12.2188 9.6475 12.2188 9.90625C12.2188 10.165 12.4288 10.375 12.6875 10.375Z"
        fill="#22AB94"
      />
      <path
        d="M3.3125 14.125C3.57138 14.125 3.78125 13.9151 3.78125 13.6562C3.78125 13.3974 3.57138 13.1875 3.3125 13.1875C3.05362 13.1875 2.84375 13.3974 2.84375 13.6562C2.84375 13.9151 3.05362 14.125 3.3125 14.125Z"
        fill="#22AB94"
      />
      <path
        d="M9.875 0C9.61612 0 9.40625 0.209875 9.40625 0.46875V1.4375C9.40625 1.69638 9.61612 1.90625 9.875 1.90625C10.1339 1.90625 10.3438 1.69638 10.3438 1.4375V0.46875C10.3438 0.209875 10.1339 0 9.875 0Z"
        fill="#22AB94"
      />
      <path
        d="M7.8862 2.06778L7.2233 1.40488C7.04027 1.22181 6.74346 1.22181 6.56039 1.40488C6.37733 1.58794 6.37733 1.88472 6.56039 2.06778L7.2233 2.73069C7.40633 2.91372 7.70317 2.91375 7.8862 2.73069C8.06927 2.54763 8.06927 2.25084 7.8862 2.06778Z"
        fill="#22AB94"
      />
      <path
        d="M13.1896 1.40487C13.0065 1.22181 12.7097 1.22181 12.5267 1.40487L11.8638 2.06775C11.6807 2.25081 11.6807 2.54759 11.8638 2.73066C12.0468 2.91372 12.3436 2.91375 12.5267 2.73069L13.1896 2.06778C13.3726 1.88472 13.3726 1.58794 13.1896 1.40487Z"
        fill="#22AB94"
      />
    </g>
    <defs>
      <clipPath id="clip0_670_4025">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const topright = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
  >
    <g clipPath="url(#clip0_670_4041)">
      <path
        d="M17.1562 6.25561L16.4352 12.5986C16.353 13.2466 15.5499 13.5386 15.0844 13.0732L14.1444 12.1331C13.8432 11.832 13.3778 11.7681 13.0766 12.0693L7.46372 17.6821C7.16254 17.9833 6.69708 18.0107 6.38678 17.7004L4.90827 16.2219C4.61621 15.9298 4.60709 15.4278 4.90827 15.1267L10.5211 9.51381C10.8223 9.21263 10.7857 8.77446 10.4846 8.47337L9.54458 7.53333C9.08825 7.077 9.3803 6.27386 10.0192 6.20085L16.28 5.41596C16.782 5.33382 17.2201 5.75364 17.1562 6.25561Z"
        fill="#22AB94"
      />
    </g>
    <defs>
      <clipPath id="clip0_670_4041">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 11.3137 22.627)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const trendingdown = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M1.98853 2.8125L0 4.80103L6.03116 10.8323L8.84366 8.01978L12.0919 11.2681L11.1403 12.2188L16 13.1875L15.0312 8.32784L14.0805 9.27953L8.84366 4.04272L6.03116 6.85522L1.98853 2.8125Z"
      fill="#E44C4B"
    />
  </svg>
);

export const trendingup = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M1.98853 13.1875L0 11.199L6.03116 5.16772L8.84366 7.98022L12.0919 4.73194L11.1403 3.78116L16 2.8125L15.0312 7.67216L14.0805 6.72047L8.84366 11.9573L6.03116 9.14478L1.98853 13.1875Z"
      fill="#22AB94"
    />
  </svg>
);

export const up = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M11.0472 16.0001V15.0625H8.00003L7.6875 15.5313L8.00003 16.0001H11.0472Z"
      fill="#22AB94"
    />
    <path
      d="M11.0472 14.1251V13.1875H8.00003L7.6875 13.6563L8.00003 14.1251H11.0472Z"
      fill="#22AB94"
    />
    <path
      d="M8.00003 0L7.6875 6.19295L8.00003 12.2496H11.0472V5.69217H13.8408L8.00003 0Z"
      fill="#22AB94"
    />
    <path
      d="M2.15927 5.69217H4.95282V12.2496H8.00002V0L2.15927 5.69217Z"
      fill="#22AB94"
    />
    <path
      d="M4.95285 13.1875H8.00005V14.1251H4.95285V13.1875Z"
      fill="#22AB94"
    />
    <path
      d="M4.95282 15.0625H8.00002V16.0001H4.95282V15.0625Z"
      fill="#22AB94"
    />
  </svg>
);

export const deleteIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icons8-delete (1) 1">
      <path
        id="Vector"
        d="M14.0632 5.27988L15.3114 5.34925L14.752 15.4186C14.6964 16.4118 13.8742 17.1896 12.8798 17.1896H7.11979C6.12511 17.1896 5.30323 16.4118 5.24761 15.4186L4.68823 5.34925L5.93636 5.27988L6.49573 15.3493C6.51417 15.6802 6.78854 15.9396 7.11979 15.9396H12.8798C13.2114 15.9396 13.4854 15.6802 13.5039 15.3489L14.0632 5.27988Z"
        fill="inherit"
      />
      <path
        id="Vector_2"
        d="M11.784 7.00007C12.0859 7.01069 12.3222 7.26382 12.3115 7.56569L12.0937 13.8426C12.0834 14.1379 11.8406 14.3704 11.5475 14.3704C11.5409 14.3704 11.5347 14.3704 11.5281 14.3701C11.2262 14.3594 10.99 14.1063 11.0006 13.8044L11.2184 7.52757C11.229 7.22601 11.4818 6.99163 11.784 7.00007Z"
        fill="inherit"
      />
      <path
        id="Vector_3"
        d="M9.09345 7.52742L9.31126 13.8043C9.32158 14.1062 9.08533 14.3593 8.78376 14.3699C8.7772 14.3699 8.77095 14.3702 8.76439 14.3702C8.47126 14.3702 8.22845 14.1377 8.21814 13.8424L8.00033 7.56554C7.99001 7.26367 8.22626 7.01054 8.52783 6.99992C8.82908 6.99273 9.08282 7.22586 9.09345 7.52742Z"
        fill="inherit"
      />
      <path
        id="Vector_4"
        d="M15.9375 4.68741C16.2825 4.68741 16.5625 4.96741 16.5625 5.31241C16.5625 5.65741 16.2825 5.93741 15.9375 5.93741H4.0625C3.7175 5.93741 3.4375 5.65741 3.4375 5.31241C3.4375 4.96741 3.7175 4.68741 4.0625 4.68741H15.9375Z"
        fill="inherit"
      />
      <path
        id="Vector_5"
        d="M11.25 2.18741C12.1116 2.18741 12.8125 2.88835 12.8125 3.74991V5.31241H11.5625V3.74991C11.5625 3.57772 11.4225 3.43741 11.25 3.43741H8.75C8.5775 3.43741 8.4375 3.57772 8.4375 3.74991V5.31241H7.1875V3.74991C7.1875 2.88835 7.88844 2.18741 8.75 2.18741H11.25Z"
        fill="inherit"
      />
    </g>
  </svg>
);

export const downArrowLight = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 7.5L10 12.5L15 7.5"
      stroke="#1E1E1E"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const downArrowDark = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 7.5L10 12.5L15 7.5"
      stroke="#EFEFEF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

// export const down = (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="16"
//     height="16"
//     viewBox="0 0 16 16"
//     fill="none"
//   >
//     <path
//       d="M11.0472 -0.000100672V0.9375H8.00003L7.6875 0.4687L8.00003 -0.000100672H11.0472Z"
//       fill="#E44C4B"
//     />
//     <path
//       d="M11.0472 1.8749V2.8125H8.00003L7.6875 2.3437L8.00003 1.8749H11.0472Z"
//       fill="#E44C4B"
//     />
//     <path
//       d="M8.00003 16L7.6875 9.80705L8.00003 3.7504H11.0472V10.3078H13.8408L8.00003 16Z"
//       fill="#E44C4B"
//     />
//     <path
//       d="M2.15927 10.3078H4.95282V3.7504H8.00002V16L2.15927 10.3078Z"
//       fill="#E44C4B"
//     />
//     <path d="M4.95285 2.8125H8.00005V1.8749H4.95285V2.8125Z" fill="#E44C4B" />
//     <path
//       d="M4.95282 0.9375H8.00002V-0.000100672H4.95282V0.9375Z"
//       fill="#E44C4B"
//     />
//   </svg>
// );

export const notificationBell = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#0000FF"
  >
    <path d="M19.2657 12.3217V10.0781C19.2657 6.80522 17.0902 4.0312 14.1094 3.12516V2.10938C14.1094 0.946266 13.1632 0 12.0001 0C10.8369 0 9.89068 0.946266 9.89068 2.10938V3.12516C6.9099 4.0312 4.73443 6.80517 4.73443 10.0781V12.3217C4.73443 15.1966 3.63859 17.9227 1.64879 19.9977C1.45379 20.2011 1.39899 20.5011 1.50952 20.7602C1.62005 21.0194 1.87459 21.1875 2.1563 21.1875H8.55516C8.88179 22.7903 10.3023 24 12.0001 24C13.6979 24 15.1183 22.7903 15.4449 21.1875H21.8438C22.1255 21.1875 22.38 21.0194 22.4905 20.7602C22.6011 20.5011 22.5463 20.2011 22.3513 19.9977C20.3615 17.9227 19.2657 15.1965 19.2657 12.3217ZM11.2969 2.10938C11.2969 1.72167 11.6124 1.40625 12.0001 1.40625C12.3878 1.40625 12.7032 1.72167 12.7032 2.10938V2.84663C12.4718 2.82431 12.2372 2.8125 12.0001 2.8125C11.7629 2.8125 11.5284 2.82431 11.2969 2.84663V2.10938ZM12.0001 22.5938C11.0834 22.5938 10.3019 22.0059 10.0116 21.1875H13.9885C13.6982 22.0059 12.9167 22.5938 12.0001 22.5938ZM3.67177 19.7812C5.27307 17.6348 6.14068 15.0371 6.14068 12.3217V10.0781C6.14068 6.84727 8.7692 4.21875 12.0001 4.21875C15.2309 4.21875 17.8594 6.84727 17.8594 10.0781V12.3217C17.8594 15.0371 18.727 17.6348 20.3284 19.7812H3.67177Z" />
    <path d="M21.1407 10.0783C21.1407 10.4666 21.4555 10.7814 21.8439 10.7814C22.2322 10.7814 22.547 10.4666 22.547 10.0783C22.547 7.2611 21.4499 4.61253 19.4579 2.62048C19.1833 2.34593 18.7381 2.34588 18.4635 2.62048C18.1889 2.89507 18.1889 3.34024 18.4635 3.61484C20.19 5.34129 21.1407 7.63671 21.1407 10.0783Z" />
    <path d="M2.15625 10.7814C2.54456 10.7814 2.85938 10.4666 2.85938 10.0783C2.85938 7.63673 3.81019 5.34131 5.53659 3.61486C5.81119 3.34026 5.81119 2.89509 5.53659 2.6205C5.26205 2.3459 4.81683 2.3459 4.54223 2.6205C2.55019 4.61254 1.45312 7.26107 1.45312 10.0783C1.45312 10.4666 1.76794 10.7814 2.15625 10.7814Z" />
  </svg>
);

export const moonIcon = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Moon icon 1">
      <path
        id="Vector"
        d="M19.0937 11C19.0937 15.47 15.47 19.0937 11 19.0937V20.4062C16.195 20.4062 20.4062 16.195 20.4062 11H19.0937ZM11 19.0937C6.52995 19.0937 2.90625 15.47 2.90625 11H1.59375C1.59375 16.195 5.80507 20.4062 11 20.4062V19.0937ZM2.90625 11C2.90625 6.52995 6.52995 2.90625 11 2.90625V1.59375C5.80507 1.59375 1.59375 5.80507 1.59375 11H2.90625ZM14.0625 12.9687C11.2838 12.9687 9.03125 10.7161 9.03125 7.9375H7.71875C7.71875 11.4411 10.5589 14.2812 14.0625 14.2812V12.9687ZM18.3721 10.5354C17.49 11.9951 15.8897 12.9687 14.0625 12.9687V14.2812C16.368 14.2812 18.3856 13.0509 19.4955 11.2141L18.3721 10.5354ZM9.03125 7.9375C9.03125 6.11034 10.0049 4.50995 11.4646 3.62784L10.7859 2.50449C8.94908 3.61439 7.71875 5.63195 7.71875 7.9375H9.03125ZM11 2.90625C10.9226 2.90625 10.8317 2.87132 10.7658 2.80272C10.71 2.74461 10.6971 2.68963 10.694 2.6674C10.6903 2.64014 10.6922 2.56112 10.7859 2.50449L11.4646 3.62784C11.9049 3.36182 12.0465 2.87473 11.9947 2.49174C11.941 2.0936 11.627 1.59375 11 1.59375V2.90625ZM19.4955 11.2141C19.4388 11.3078 19.3598 11.3097 19.3326 11.306C19.3104 11.3029 19.2554 11.29 19.1973 11.2341C19.1287 11.1683 19.0937 11.0774 19.0937 11H20.4062C20.4062 10.373 19.9064 10.059 19.5082 10.0053C19.1252 9.9535 18.6381 10.0951 18.3721 10.5354L19.4955 11.2141Z"
        fill="#111A21"
      />
    </g>
  </svg>
);

export const plusCircleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <g clipPath="url(#clip0_151_778)">
      <path d="M14.75 21.6238V17.2488H10.375C9.68457 17.2488 9.125 16.6892 9.125 15.9988C9.125 15.3086 9.68457 14.7488 10.375 14.7488H14.75V10.3738C14.75 9.68359 15.3096 9.12378 16 9.12378C16.6904 9.12378 17.25 9.68359 17.25 10.3738V14.7488H21.625C22.3154 14.7488 22.875 15.3086 22.875 15.9988C22.875 16.6892 22.3154 17.2488 21.625 17.2488H17.25V21.6238C17.25 22.3142 16.6904 22.8738 16 22.8738C15.3096 22.8738 14.75 22.3142 14.75 21.6238ZM27.3137 4.68628C24.2917 1.66431 20.2737 0 16 0C11.7263 0 7.70825 1.66431 4.68628 4.68628C1.66431 7.70825 0 11.7263 0 16C0 20.2737 1.66431 24.2917 4.68628 27.3137C7.70825 30.3357 11.7263 32 16 32C18.9258 32 21.7886 31.2026 24.2788 29.6941C24.8694 29.3364 25.0581 28.5679 24.7004 27.9775C24.3428 27.387 23.574 27.1982 22.9836 27.5559C20.884 28.8276 18.469 29.5 16 29.5C8.55615 29.5 2.5 23.4438 2.5 16C2.5 8.55615 8.55615 2.5 16 2.5C23.4438 2.5 29.5 8.55615 29.5 16C29.5 18.6619 28.7085 21.2527 27.2109 23.4929C26.8271 24.0667 26.9814 24.843 27.5554 25.2268C28.1292 25.6104 28.9055 25.4561 29.2893 24.8823C31.0625 22.2297 32 19.1582 32 16C32 11.7263 30.3357 7.70825 27.3137 4.68628Z" />
    </g>
    <defs>
      <clipPath id="clip0_151_778">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const alarmClockIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <path
      d="M4.97421 9.26145C5.39759 9.26145 5.82349 9.11876 6.17402 8.82635L11.2652 4.5807C12.0605 3.91751 12.1676 2.73514 11.5044 1.93986C10.8412 1.14457 9.6588 1.03742 8.86352 1.7007L3.77234 5.94654C2.97706 6.60973 2.86999 7.79211 3.53318 8.58739C3.90406 9.03195 4.43712 9.26145 4.97421 9.26145Z"
      fill="black"
    />
    <path
      d="M36.735 4.58216L41.8262 8.82781C42.1768 9.12022 42.6026 9.26291 43.026 9.26291C43.5631 9.26291 44.0962 9.03341 44.467 8.58875C45.1302 7.79347 45.0231 6.61109 44.2279 5.94791L39.1367 1.70216C38.3414 1.03897 37.159 1.14594 36.4958 1.94131C35.8326 2.73659 35.9397 3.91887 36.735 4.58216Z"
      fill="black"
    />
    <path
      d="M39.6449 10.2302C35.8887 6.47409 31.0197 4.236 25.7815 3.82134V1.875C25.7815 0.839438 24.9421 0 23.9065 0C22.8709 0 22.0315 0.839438 22.0315 1.875V3.83747C16.8646 4.29019 12.0669 6.519 8.35562 10.2303C4.17671 14.409 1.87524 19.9651 1.87524 25.8748C1.87524 31.7845 4.17671 37.3407 8.35553 41.5194C8.74309 41.907 9.14265 42.2783 9.55309 42.6332L8.0454 45.1657C7.51571 46.0554 7.80756 47.2062 8.69734 47.7359C8.99809 47.9149 9.32846 48 9.65471 48C10.2939 48 10.9169 47.673 11.2676 47.0839L12.5998 44.8461C16.0066 46.9016 19.9189 47.9997 24.0001 47.9997C28.0651 47.9997 31.9662 46.9141 35.3985 44.8426L36.7327 47.0838C37.0834 47.6729 37.7063 47.9999 38.3456 47.9999C38.6717 47.9999 39.0023 47.9148 39.303 47.7358C40.1927 47.2061 40.4846 46.0553 39.9549 45.1656L37.6111 41.2286C37.3405 40.7738 36.8902 40.4547 36.3714 40.3499C35.8529 40.2452 35.3138 40.3643 34.8878 40.6782C31.717 43.0148 27.9521 44.2497 24.0001 44.2497C13.8682 44.2497 5.62524 36.0068 5.62524 25.8748C5.62524 15.7428 13.8682 7.5 24.0001 7.5C34.1321 7.5 42.3751 15.7429 42.3751 25.8749C42.3751 28.9697 41.5918 32.0286 40.11 34.7207C39.6106 35.6279 39.9413 36.7681 40.8485 37.2674C41.7556 37.7666 42.8959 37.4361 43.3952 36.5288C45.1811 33.2842 46.1251 29.6001 46.1251 25.8748C46.1251 19.9651 43.8237 14.409 39.6449 10.2302Z"
      fill="black"
    />
    <path
      d="M23.9062 12.0938C22.8707 12.0938 22.0312 12.9332 22.0312 13.9688V25.8749C22.0312 26.3722 22.2288 26.8492 22.5804 27.2008L27.8837 32.5041C28.2498 32.8701 28.7296 33.0532 29.2095 33.0532C29.6894 33.0532 30.1692 32.8701 30.5353 32.5041C31.2676 31.7719 31.2676 30.5846 30.5353 29.8523L25.7812 25.0983V13.9688C25.7812 12.9332 24.9418 12.0938 23.9062 12.0938Z"
      fill="black"
    />
  </svg>
);

export const sunIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#EFEFEF"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-sun"
  >
    <circle cx="12" cy="12" r="5"></circle>
    <line x1="12" y1="1" x2="12" y2="3"></line>
    <line x1="12" y1="21" x2="12" y2="23"></line>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
    <line x1="1" y1="12" x2="3" y2="12"></line>
    <line x1="21" y1="12" x2="23" y2="12"></line>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
  </svg>
);

export const emptyClipBoard = (
  <svg
    width="126"
    height="126"
    viewBox="0 0 126 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_668_2915)">
      <path d="M91.0543 12.3047H80.5499C79.6976 10.8348 78.1067 9.84402 76.2888 9.84402H61.2764C60.133 4.23458 55.1607 6.10352e-05 49.2186 6.10352e-05C43.2764 6.10352e-05 38.3041 4.23458 37.161 9.84402H22.1483C20.3305 9.84402 18.7395 10.8348 17.8873 12.3047H7.38278C3.31192 12.3047 0 15.6166 0 19.6875V118.617C0 122.688 3.31192 126 7.38278 126H91.0543C95.1252 126 98.4371 122.688 98.4371 118.617V19.6875C98.4371 15.6166 95.1252 12.3047 91.0543 12.3047ZM39.3746 14.7659C40.7335 14.7659 41.8355 13.6639 41.8355 12.3049C41.8355 8.23383 45.1474 4.92192 49.2186 4.92192C53.2897 4.92192 56.6018 8.23383 56.6018 12.3049C56.6018 13.6639 57.7038 14.7659 59.0628 14.7659H76.2888V24.6093H22.1483L22.1479 14.7659H39.3746ZM93.5153 118.617C93.5153 119.974 92.4113 121.078 91.0543 121.078H7.38278C6.02583 121.078 4.92186 119.974 4.92186 118.617V19.6875C4.92186 18.3305 6.02583 17.2266 7.38278 17.2266H17.2265V22.1484H12.3049C10.946 22.1484 9.84396 23.2504 9.84396 24.6093V113.695C9.84396 115.054 10.946 116.156 12.3049 116.156H38.1436C39.5026 116.156 40.6046 115.054 40.6046 113.695C40.6046 112.336 39.5026 111.234 38.1436 111.234H14.7658V27.0703H17.887C18.7392 28.5404 20.3302 29.5312 22.1483 29.5312H76.2888C78.1069 29.5312 79.6979 28.5404 80.5501 27.0703H83.6715V111.234H60.292C58.9331 111.234 57.8311 112.336 57.8311 113.695C57.8311 115.054 58.9331 116.156 60.292 116.156H86.1325C87.4914 116.156 88.5934 115.054 88.5934 113.695V24.6093C88.5934 23.2504 87.4914 22.1484 86.1325 22.1484H81.2106V17.2266H91.0543C92.4113 17.2266 93.5153 18.3305 93.5153 19.6875V118.617Z" />
      <path d="M49.2197 14.7661C50.5787 14.7661 51.6807 13.6641 51.6807 12.3052C51.6807 10.9462 50.5787 9.84424 49.2197 9.84424H49.2178C47.8588 9.84424 46.7578 10.9462 46.7578 12.3052C46.7578 13.6641 47.8606 14.7661 49.2197 14.7661Z" />
      <path d="M115.65 26.7904C115.233 25.9566 114.381 25.4302 113.449 25.4302H106.066C104.708 25.4302 103.606 26.5322 103.606 27.8911C103.606 29.2501 104.708 30.3521 106.066 30.3521H108.527L104.098 36.2583C103.539 37.004 103.448 38.0017 103.865 38.8357C104.282 39.6694 105.134 40.1958 106.066 40.1958H113.449C114.808 40.1958 115.91 39.0938 115.91 37.7349C115.91 36.376 114.808 35.274 113.449 35.274H110.988L115.418 29.3677C115.977 28.6218 116.067 27.6244 115.65 26.7904Z" />
      <path d="M123.539 13.1252H118.617L125.508 3.93774C126.067 3.19208 126.157 2.19442 125.74 1.3604C125.323 0.526639 124.471 0.000244141 123.539 0.000244141H113.695C112.336 0.000244141 111.234 1.10225 111.234 2.46118C111.234 3.82011 112.336 4.92212 113.695 4.92212H118.617L111.727 14.1095C111.167 14.8552 111.077 15.8529 111.494 16.6866C111.911 17.5206 112.763 18.047 113.695 18.047H123.539C124.898 18.047 126 16.945 126 15.5861C126 14.2272 124.898 13.1252 123.539 13.1252Z" />
      <path d="M37.1166 59.1376C36.1952 60.0589 34.9702 60.5666 33.6671 60.5666C32.3643 60.5666 31.1395 60.0592 30.2179 59.1376C29.2566 58.1768 27.6988 58.1768 26.7373 59.1376C25.7764 60.0986 25.7764 61.6568 26.7373 62.6181C28.5885 64.4689 31.0494 65.4885 33.6669 65.4885C36.2846 65.4885 38.7455 64.4689 40.5966 62.6181C41.5576 61.6571 41.5576 60.0988 40.5966 59.1376C39.6359 58.1768 38.0778 58.1768 37.1166 59.1376Z" />
      <path d="M64.7696 65.4885C67.3873 65.4885 69.8483 64.4689 71.6994 62.6181C72.6604 61.6571 72.6604 60.0988 71.6994 59.1376C70.7382 58.1768 69.1804 58.1768 68.2189 59.1376C67.2975 60.0589 66.0725 60.5666 64.7694 60.5666C63.4663 60.5666 62.2415 60.0592 61.3199 59.1376C60.3587 58.1768 58.8009 58.1768 57.8394 59.1376C56.8784 60.0986 56.8784 61.6568 57.8394 62.6181C59.6913 64.4689 62.1522 65.4885 64.7696 65.4885Z" />
      <path d="M52.6946 74.9661H45.7427C44.3837 74.9661 43.2817 76.0681 43.2817 77.427C43.2817 78.7859 44.3837 79.8879 45.7427 79.8879H52.6946C54.0535 79.8879 55.1555 78.7859 55.1555 77.427C55.1555 76.0681 54.0535 74.9661 52.6946 74.9661Z" />
      <path d="M49.2188 111.234H49.2168C47.8579 111.234 46.7568 112.336 46.7568 113.695C46.7568 115.054 47.8596 116.156 49.2188 116.156C50.5779 116.156 51.6797 115.054 51.6797 113.695C51.6797 112.336 50.5777 111.234 49.2188 111.234Z" />
    </g>
    <defs>
      <clipPath id="clip0_668_2915">
        <rect width="126" height="126" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
